/* FlowForge 2 — FlowStar print designer (customer studio + StarForge Admin renderer).
   GENERATED by flowforge/build.py from flowforge/src/*.js.
   Edit the sources, then rebuild. */
/* ── 00-head.js ── */
(function () {
'use strict';

/* FlowForge 2 runs inside the Shopify section (customers) and inside StarForge Admin (Brian, on his PC):
   - customers only ever see 1024 px pattern previews and get an 800 px hand-off image; never a print file
   - admin mode (window.STARFORGE_ADMIN, set by starforge-admin.py) swaps every pattern for the original
     from Z: and exports 6000 px print files with the same renderer, so screen and print always match. */
const ROOT = document.querySelector('[data-flowforge]');
if (!ROOT) return;
const ADMIN = !!window.STARFORGE_ADMIN;
if (ADMIN) document.body.classList.add('sf-admin');
const SETTINGS = readJSON(ROOT.querySelector('script[data-ff-settings]')) || {};

function readJSON(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }

/* ── 01-util.js ── */
/* ── NUMBERS, TEXT, IDS ── */
function clampNum(v, lo, hi, dflt) { v = Number(v); return isFinite(v) ? Math.min(hi, Math.max(lo, v)) : dflt; }
function round(v, p) { const k = Math.pow(10, p == null ? 2 : p); return Math.round(v * k) / k; }
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
/* design codes and share links arrive from outside: only plain-text pattern keys, names and short text */
function cleanKey(k) { return (typeof k === 'string' && k.length < 400 && !/[\\\u0000-\u001f"<>]/.test(k) && k.split('/').indexOf('..') < 0) ? k : ''; }
function cleanName(n) { return String(n == null ? '' : n).replace(/[<>"&]/g, '').slice(0, 120); }
function cleanText(t, max) { return String(t == null ? '' : t).replace(/[\u0000-\u001f\u007f]/g, '').slice(0, max || 48); }
function isHex(v) { return typeof v === 'string' && /^#[0-9a-f]{6}$/i.test(v); }
function cleanHex(v, d) { return isHex(v) ? v.toLowerCase() : d; }
function oneOf(v, list, d) { return list.indexOf(v) >= 0 ? v : d; }
function snap45(v) { return ((Math.round(clampNum(v, -3600, 3600, 0) / 45) * 45) % 360 + 360) % 360; }
function norm360(v) { return ((clampNum(v, -36000, 36000, 0) % 360) + 360) % 360; }
function deepClone(o) { return JSON.parse(JSON.stringify(o)); }
function fx(v) { return (Math.round(v * 100) / 100).toString(); }

/* seeded randomness: the same seed always gives the same design (mulberry32) */
function rng(seed) {
  let a = (seed >>> 0) || 1;
  function next() {
    a |= 0; a = a + 0x6D2B79F5 | 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  }
  return {
    next,
    int(lo, hi) { return lo + Math.floor(next() * (hi - lo + 1)); },
    range(lo, hi) { return lo + next() * (hi - lo); },
    pick(arr) { return arr[Math.floor(next() * arr.length)]; },
    chance(p) { return next() < p; },
    shuffle(arr) { const a2 = arr.slice(); for (let i = a2.length - 1; i > 0; i--) { const j = Math.floor(next() * (i + 1)); const t = a2[i]; a2[i] = a2[j]; a2[j] = t; } return a2; }
  };
}

/* ── COLOUR ── */
function hexToRgb(h) { h = cleanHex(h, '#000000'); return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }
function rgbToHex(r, g, b) { return '#' + [r, g, b].map(v => Math.round(clampNum(v, 0, 255, 0)).toString(16).padStart(2, '0')).join(''); }
function hexToHsl(h) {
  const c = hexToRgb(h).map(v => v / 255), mx = Math.max(c[0], c[1], c[2]), mn = Math.min(c[0], c[1], c[2]);
  let hh = 0, s = 0; const l = (mx + mn) / 2, d = mx - mn;
  if (d) {
    s = d / (1 - Math.abs(2 * l - 1));
    hh = mx === c[0] ? ((c[1] - c[2]) / d) % 6 : mx === c[1] ? (c[2] - c[0]) / d + 2 : (c[0] - c[1]) / d + 4;
    hh = (hh * 60 + 360) % 360;
  }
  return [hh, s * 100, l * 100];
}
function hslToHex(h, s, l) {
  h = ((h % 360) + 360) % 360; s = clampNum(s, 0, 100, 0) / 100; l = clampNum(l, 0, 100, 0) / 100;
  const c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs((h / 60) % 2 - 1)), m = l - c / 2;
  const rgb = h < 60 ? [c, x, 0] : h < 120 ? [x, c, 0] : h < 180 ? [0, c, x] : h < 240 ? [0, x, c] : h < 300 ? [x, 0, c] : [c, 0, x];
  return rgbToHex((rgb[0] + m) * 255, (rgb[1] + m) * 255, (rgb[2] + m) * 255);
}
function mixHex(a, b, t) {
  const A = hexToRgb(a), B = hexToRgb(b);
  return rgbToHex(A[0] + (B[0] - A[0]) * t, A[1] + (B[1] - A[1]) * t, A[2] + (B[2] - A[2]) * t);
}
function luminance(h) {
  const c = hexToRgb(h).map(v => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
}
function colorDistance(a, b) { const A = hexToRgb(a), B = hexToRgb(b); return Math.sqrt(2 * (A[0] - B[0]) ** 2 + 4 * (A[1] - B[1]) ** 2 + 3 * (A[2] - B[2]) ** 2); }

/* legacy SF1 overlay tint: H/S/B where B 0-100 = black to full colour, 100-200 = full colour to white */
function hsbToHsl(h, s, b) {
  h = clampNum(h, 0, 360, 0); s = clampNum(s, 0, 100, 100) / 100; b = clampNum(b, 0, 200, 50) / 100;
  const toWhite = Math.max(0, b - 1); b = Math.min(b, 1);
  let l = b * (1 - s / 2);
  const sl = (l === 0 || l === 1) ? 0 : (b - l) / Math.min(l, 1 - l);
  l = l + (1 - l) * toWhite;
  return 'hsl(' + h + ',' + Math.round(sl * 100) + '%,' + (Math.round(l * 1000) / 10) + '%)';
}

/* palettes the generator and the colour picker offer: hand-tuned, not random RGB */
const VIBES = {
  neon:   { label: 'Neon rave',     ground: '#0b0716', colors: ['#ff2bd6', '#2bf0ff', '#c6ff2b', '#ffe42b', '#8a3dff'] },
  cosmic: { label: 'Cosmic',        ground: '#0b1033', colors: ['#3a1d78', '#8f3fd1', '#e86bff', '#ffd36e', '#e9f1ff'] },
  sunset: { label: 'Sunset',        ground: '#2b0f2e', colors: ['#7a1f4b', '#e0424b', '#ff8a3d', '#ffd166', '#fff3d6'] },
  ocean:  { label: 'Deep ocean',    ground: '#03142b', colors: ['#0a4a6e', '#0f8fa3', '#3fd6c9', '#bff7ee', '#f4fffd'] },
  earth:  { label: 'Earthy boho',   ground: '#2b1a0a', colors: ['#6b3f1d', '#b5651d', '#d9a441', '#8a9a5b', '#f1e3c8'] },
  hypno:  { label: 'Hypnotic B&W',  ground: '#0d0d0d', colors: ['#f7f4ee', '#0d0d0d', '#d81e2a', '#f7f4ee', '#7a7a7a'] },
  candy:  { label: 'Candy',         ground: '#3a1240', colors: ['#ff6fb5', '#ffd0e8', '#7fd8ff', '#c3a6ff', '#fff07a'] },
  fire:   { label: 'Fire',          ground: '#1a0500', colors: ['#7a0c00', '#d62600', '#ff6a00', '#ffb300', '#fff2b3'] },
  forest: { label: 'Forest spirit', ground: '#0c1a10', colors: ['#1f4d2b', '#3f8f4a', '#9fd36a', '#e8d27a', '#f4f0dc'] },
  royal:  { label: 'Royal gold',    ground: '#1e1209', colors: ['#3b2410', '#7a1f2b', '#e3a92b', '#f0c25a', '#fbf6ec'] }
};
/* gradient presets for every colour picker; rainbow is the classic flow-toy spectrum */
const GRADIENTS = {
  rainbow: ['#ff3b3b', '#ff9f1c', '#ffe14d', '#3ddc84', '#2bb5ff', '#7a5cff', '#ff4fd8'],
  sunset:  ['#2b0f2e', '#e0424b', '#ff8a3d', '#ffd166'],
  ocean:   ['#03142b', '#0f8fa3', '#3fd6c9', '#e8fffb'],
  toxic:   ['#c6ff00', '#00ff9c', '#00c2ff'],
  fire:    ['#3a0000', '#d62600', '#ff8a00', '#ffe066'],
  uv:      ['#2b0bff', '#b21cff', '#ff2bd6'],
  pastel:  ['#ffd0e8', '#c3a6ff', '#a6e3ff', '#d8ffc2'],
  gold:    ['#5a3a00', '#e3a92b', '#fff3b0', '#e3a92b'],
  mono:    ['#0d0d0d', '#f7f4ee']
};
const SWATCHES = ['#0d0d0d', '#f7f4ee', '#d81e2a', '#ff6a00', '#ffd23f', '#3ddc84', '#1fb6c9', '#2b5cff', '#7a3dff', '#ff2bd6',
  '#ff9fc8', '#c6ff2b', '#2bf0ff', '#e3a92b', '#6b3f1d', '#1e1209', '#7a7a7a', '#bff7ee'];

/* ── 02-geometry.js ── */
/* ── PATTERN KEYS ──
   Customers only get 1024 px previews: CDN_BASE/previews/<key> (overlays: <key>.png). A design stores
   preview URLs; design codes store plain keys ('30K Seamless Pack/…/x.jpg'). In admin mode
   (starforge-admin.py) previews and manifests come from the PC and every image is swapped for the original. */
const CDN_BASE = 'https://pub-1a1f9417baa64ab1b0a958075feda0d2.r2.dev';
const CONFIGURATOR_URL = SETTINGS.configuratorUrl || '/pages/configurator';
const PREVIEW_BASE = ADMIN ? '/previews/' : (SETTINGS.previewBase || CDN_BASE + '/previews/');
const MANIFEST_BASE = ADMIN ? '' : (SETTINGS.manifestBase != null ? SETTINGS.manifestBase : CDN_BASE);
const LOGO_KEY = 'Branding/bpd-logo.png', LOGO_ASPECT = 4103 / 3566;   /* height / width */

function urlToKey(url) {
  if (!url) return '';
  const rest = url.indexOf(PREVIEW_BASE) === 0 ? url.slice(PREVIEW_BASE.length)
    : url.indexOf(CDN_BASE + '/previews/') === 0 ? url.slice(CDN_BASE.length + 10)
    : url.indexOf(CDN_BASE + '/') === 0 ? url.slice(CDN_BASE.length + 1) : '';
  if (!rest) return '';
  const key = rest.split('/').map(p => { try { return decodeURIComponent(p); } catch (e) { return p; } }).join('/');
  return key.replace(/\.svg\.png$/i, '.svg');
}
function keyToUrl(key) {
  if (!key) return '';
  const k = /\.svg$/i.test(key) ? key + '.png' : key;
  return PREVIEW_BASE + k.split('/').map(encodeURIComponent).join('/');
}
/* the image actually drawn: the preview for customers, the original from Z: in admin */
function srcFor(url) {
  if (!url || !ADMIN) return url;
  const key = urlToKey(url);
  return key ? '/orig/' + key.split('/').map(encodeURIComponent).join('/') : url;
}
/* overlays whose key is not an .svg are full-colour images (transparent PNGs): shown in their own colours */
function isColorOverlay(url) { const k = urlToKey(url); return !!k && !/\.svg$/i.test(k); }

/* ── STAR GEOMETRY ──
   A FlowStar face = two equal squares sharing a centre, one turned 45 deg (the 8-point star {8/2}).
   viewBox 400, star points on a 180 radius (90 %). "top square" = the diamond (point straight up),
   "bottom square" = the flat-top square; the configurator's colour tiers address the same squares. */
const VB = 400, CX = 200, CY = 200, R = 180;
const RIN = R * Math.sqrt(2 - Math.SQRT2);       /* inner notch radius, ~0.765 R */
const RIN_APOTHEM = RIN * Math.cos(Math.PI / 8); /* the centre octagon's inscribed circle, ~0.707 R */
const K = R / 92;                                /* the configurator preview's units -> ours */

function polar(r, deg, cx, cy) {
  const a = deg * Math.PI / 180;
  return { x: (cx == null ? CX : cx) + r * Math.sin(a), y: (cy == null ? CY : cy) - r * Math.cos(a) };
}
function pt(p) { return fx(p.x) + ' ' + fx(p.y); }
const OUTER = [], INNER = [];
for (let k = 0; k < 8; k++) { OUTER.push(polar(R, k * 45)); INNER.push(polar(RIN, k * 45 + 22.5)); }
const STAR_PATH = 'M ' + OUTER.map((o, k) => pt(o) + ' L ' + pt(INNER[k])).join(' L ') + ' Z';
/* point k = the triangle outside the centre octagon: notch k-1, tip k, notch k */
function tipPath(k) { return 'M ' + pt(INNER[(k + 7) % 8]) + ' L ' + pt(OUTER[k]) + ' L ' + pt(INNER[k]) + ' Z'; }
function tipCentroid(k) {
  const a = INNER[(k + 7) % 8], o = OUTER[k], b = INNER[k];
  return { x: (a.x + o.x + b.x) / 3, y: (a.y + o.y + b.y) / 3 };
}
const TIP_HALF_BASE = Math.hypot(INNER[0].x - INNER[7].x, INNER[0].y - INNER[7].y) / 2;
const TIP_HEIGHT = R - RIN_APOTHEM;

/* wedge i = the 45 deg slice centred on point i (SF1 geometry, unchanged) */
function wedgeClipPath(index) {
  const startDeg = index * 45 - 22.5, endDeg = startDeg + 45, far = 350;
  const s = (startDeg - 90) * Math.PI / 180, e = (endDeg - 90) * Math.PI / 180;
  return 'M ' + CX + ' ' + CY + ' L ' + (CX + far * Math.cos(s)).toFixed(2) + ' ' + (CY + far * Math.sin(s)).toFixed(2) +
    ' A ' + far + ' ' + far + ' 0 0 1 ' + (CX + far * Math.cos(e)).toFixed(2) + ' ' + (CY + far * Math.sin(e)).toFixed(2) + ' Z';
}
const WEDGE_LABELS = ['Top', 'Top right', 'Right', 'Bottom right', 'Bottom', 'Bottom left', 'Left', 'Top left'];
const POINT_LABELS = WEDGE_LABELS;

/* a ring between r0 and r1 (or a disc when r0 = 0); fill-rule evenodd */
function annulusPath(r0, r1, cx, cy) {
  cx = cx == null ? CX : cx; cy = cy == null ? CY : cy;
  const circ = r => 'M ' + fx(cx + r) + ' ' + fx(cy) + ' A ' + fx(r) + ' ' + fx(r) + ' 0 1 1 ' + fx(cx - r) + ' ' + fx(cy) +
    ' A ' + fx(r) + ' ' + fx(r) + ' 0 1 1 ' + fx(cx + r) + ' ' + fx(cy) + ' Z ';
  return circ(Math.max(r1, 0.01)) + (r0 > 0.3 ? circ(r0) : '');
}
/* ── TRIM COVERAGE (screen only) ──
   The binding is chosen and priced in the configurator; here it only shows which parts of the print the
   two square bindings cover. One width for every star: the most common binding, 3/4" (20 mm) on a 24" star
   (tip to tip = 2R, so 1" = 2R / 24 viewBox units). The stroke is centred on the edge, like the binding. */
const SQUARE = { ts: [OUTER[0], OUTER[2], OUTER[4], OUTER[6]], bs: [OUTER[1], OUTER[3], OUTER[5], OUTER[7]] };
const TRIM_IN = 0.75, TRIM_STAR_IN = 24;
function trimStrokeW() { return TRIM_IN * 2 * R / TRIM_STAR_IN; }

/* ── 03-paint.js ── */
/* ── PAINT ──
   Every colour slot (background, rings, points, art tint, text) takes a paint:
     '#rrggbb'                                          solid
     { t: 'linear'|'radial'|'sweep', a: deg, s: [[0..1, '#rrggbb'], …] }   gradient, 2-8 stops
   linear: a = direction (0 = left to right).  radial: centre out (rings map it inner to outer edge).
   sweep: round the centre of the star starting at a (SVG has no conic gradient: drawn as a fine fan). */
function gradPaint(name, t, a) {
  const c = GRADIENTS[name] || GRADIENTS.rainbow;
  return { t: t || 'linear', a: a || 0, s: c.map((h, i) => [round(i / (c.length - 1), 3), h]) };
}
function cleanPaint(p, d) {
  if (isHex(p)) return p.toLowerCase();
  if (p && typeof p === 'object' && ['linear', 'radial', 'sweep'].indexOf(p.t) >= 0 && Array.isArray(p.s)) {
    const s = p.s.slice(0, 8).filter(st => Array.isArray(st))
      .map(st => [round(clampNum(st[0], 0, 1, 0), 3), cleanHex(st[1], '#000000')]).sort((x, y) => x[0] - y[0]);
    if (s.length >= 2) return { t: p.t, a: round(norm360(p.a || 0), 1), s };
  }
  return d === undefined ? '#000000' : d;
}
function paintColors(p) { return isHex(p) ? [p] : p.s.map(s => s[1]); }
function paintIsGradient(p) { return !!p && !isHex(p); }
/* colour at position t (0..1) along a paint; a solid paint steps round the colour wheel instead */
function samplePaint(p, t, n) {
  if (isHex(p)) {
    if (!n || n < 2) return p;
    const hsl = hexToHsl(p);
    return hslToHex(hsl[0] + 360 * t, Math.max(hsl[1], 55), clampNum(hsl[2], 35, 70, 50));
  }
  const s = p.s;
  if (t <= s[0][0]) return s[0][1];
  for (let i = 1; i < s.length; i++) {
    if (t <= s[i][0]) { const span = (s[i][0] - s[i - 1][0]) || 1; return mixHex(s[i - 1][1], s[i][1], (t - s[i - 1][0]) / span); }
  }
  return s[s.length - 1][1];
}
function paintCss(p) {
  if (isHex(p)) return p;
  const stops = p.s.map(s => s[1] + ' ' + Math.round(s[0] * 100) + '%').join(', ');
  if (p.t === 'radial') return 'radial-gradient(circle, ' + stops + ')';
  if (p.t === 'sweep') return 'conic-gradient(from ' + p.a + 'deg, ' + stops + ')';
  return 'linear-gradient(' + (p.a + 90) + 'deg, ' + stops + ')';
}

/* render context: unique ids per SVG (several stars can be on the page at once) + collected <defs> */
function makeCtx(idp) {
  let n = 0;
  return { idp, defs: [], id(p) { return idp + '-' + (p || 'd') + (n++).toString(36); }, fonts: {} };
}
/* box = what a gradient spans: { cx, cy, r, r0 } (r0 > 0: a radial gradient runs from r0 to r) */
function paintRef(ctx, p, box) {
  if (isHex(p)) return { fill: p };
  if (p.t === 'sweep') return { fill: '#ffffff', sweep: true };
  const id = ctx.id('g');
  if (p.t === 'linear') {
    const a = p.a * Math.PI / 180, dx = Math.cos(a) * box.r, dy = Math.sin(a) * box.r;
    const stops = p.s.map(s => '<stop offset="' + s[0] + '" stop-color="' + s[1] + '"/>').join('');
    ctx.defs.push('<linearGradient id="' + id + '" gradientUnits="userSpaceOnUse" x1="' + fx(box.cx - dx) + '" y1="' + fx(box.cy - dy) +
      '" x2="' + fx(box.cx + dx) + '" y2="' + fx(box.cy + dy) + '">' + stops + '</linearGradient>');
  } else {
    const r0 = Math.max(0, Math.min(box.r0 || 0, box.r - 0.5)), span = box.r - r0;
    const stops = p.s.map(s => '<stop offset="' + round((r0 + s[0] * span) / box.r, 4) + '" stop-color="' + s[1] + '"/>').join('');
    ctx.defs.push('<radialGradient id="' + id + '" gradientUnits="userSpaceOnUse" cx="' + fx(box.cx) + '" cy="' + fx(box.cy) + '" r="' + fx(box.r) + '">' + stops + '</radialGradient>');
  }
  return { fill: 'url(#' + id + ')' };
}
/* a sweep gradient: a fan of thin wedges round the centre, shown through a mask of the shape */
/* wedges per sweep: 96 is smooth on screen; renderSide raises it for the 800 px handoff and the
   6000 px print, where 3.75 degree colour steps show as stripes */
let SWEEP_N = 96;
function sweepFan(p, rot, cx, cy) {
  cx = cx == null ? CX : cx; cy = cy == null ? CY : cy;
  const N = SWEEP_N, step = 360 / N, far = VB * 1.5;
  let out = '';
  for (let i = 0; i < N; i++) {
    const a0 = rot + i * step - 0.3, a1 = rot + (i + 1) * step + 0.3; /* overlap: no hairline gaps */
    out += '<path d="M ' + fx(cx) + ' ' + fx(cy) + ' L ' + pt(polar(far, a0, cx, cy)) + ' L ' + pt(polar(far, a1, cx, cy)) +
      ' Z" fill="' + samplePaint(p, (i + 0.5) / N) + '"/>';
  }
  return out;
}
function maskedSweep(ctx, p, rot, whiteMarkup) {
  const id = ctx.id('m');
  ctx.defs.push('<mask id="' + id + '" maskUnits="userSpaceOnUse" x="' + (-VB) + '" y="' + (-VB) + '" width="' + (3 * VB) + '" height="' + (3 * VB) + '">' + whiteMarkup + '</mask>');
  return '<g mask="url(#' + id + ')">' + sweepFan(p, rot) + '</g>';
}
/* one path painted with p.  kind 'fill' | 'stroke' (w = stroke width).  extra = more attributes */
function paintPath(ctx, p, d, kind, box, w, extra) {
  const ref = paintRef(ctx, p, box);
  const attrs = kind === 'stroke'
    ? ' fill="none" stroke-width="' + fx(w) + '" stroke-linecap="round" stroke-linejoin="round"'
    : ' fill-rule="evenodd"';
  if (!ref.sweep) {
    return '<path d="' + d + '"' + attrs + (kind === 'stroke' ? ' stroke="' + ref.fill + '"' : ' fill="' + ref.fill + '"') + (extra || '') + '/>';
  }
  const white = '<path d="' + d + '"' + attrs + (kind === 'stroke' ? ' stroke="#fff"' : ' fill="#fff"') + '/>';
  return maskedSweep(ctx, p, p.a || 0, white) + (extra ? '<path d="' + d + '" fill="none"' + extra + '/>' : '');
}

/* ── 04-motifs.js ── */
/* ── MOTIFS ──
   Vector building blocks for mandala rings and the 8 points. Everything is drawn as path data in the
   400-unit viewBox, so it stays razor sharp in the 6000 px print file.
   Small shapes are written in a local frame (about -1..1; -y points away from the star centre) and
   placed with place(): local x runs along the ring, local y runs along the radius. */
const CIRCLE_L = ['M', 0, -1, 'C', 0.5523, -1, 1, -0.5523, 1, 0, 'C', 1, 0.5523, 0.5523, 1, 0, 1, 'C', -0.5523, 1, -1, 0.5523, -1, 0, 'C', -1, -0.5523, -0.5523, -1, 0, -1, 'Z'];
const SHAPES = {
  heart: ['M', 0, 0.95, 'C', -0.15, 0.8, -1, 0.25, -1, -0.3, 'C', -1, -0.75, -0.6, -0.95, -0.3, -0.95, 'C', -0.12, -0.95, 0, -0.8, 0, -0.62,
    'C', 0, -0.8, 0.12, -0.95, 0.3, -0.95, 'C', 0.6, -0.95, 1, -0.75, 1, -0.3, 'C', 1, 0.25, 0.15, 0.8, 0, 0.95, 'Z'],
  leaf: ['M', 0, -1, 'C', 0.62, -0.45, 0.62, 0.45, 0, 1, 'C', -0.62, 0.45, -0.62, -0.45, 0, -1, 'Z'],
  flame: ['M', 0, 1, 'C', -0.75, 0.75, -0.72, 0.05, -0.25, -0.45, 'C', -0.1, -0.62, -0.05, -0.85, 0, -1, 'C', 0.25, -0.7, 0.75, -0.3, 0.66, 0.3,
    'C', 0.6, 0.72, 0.3, 1, 0, 1, 'Z'],
  drop: ['M', 0, -1, 'C', 0.35, -0.5, 0.7, -0.05, 0.7, 0.35, 'C', 0.7, 0.75, 0.38, 1, 0, 1, 'C', -0.38, 1, -0.7, 0.75, -0.7, 0.35,
    'C', -0.7, -0.05, -0.35, -0.5, 0, -1, 'Z'],
  diamond: ['M', 0, -1, 'L', 1, 0, 'L', 0, 1, 'L', -1, 0, 'Z'],
  eye: ['M', -1, 0, 'C', -0.5, -0.78, 0.5, -0.78, 1, 0, 'C', 0.5, 0.78, -0.5, 0.78, -1, 0, 'Z',
    'M', -0.74, 0, 'C', -0.37, 0.55, 0.37, 0.55, 0.74, 0, 'C', 0.37, -0.55, -0.37, -0.55, -0.74, 0, 'Z'].concat(scaleShape(CIRCLE_L, 0.3, 0.3))
};
SHAPES.star = (function () { const s = ['M']; for (let i = 0; i < 10; i++) { const r = i % 2 ? 0.42 : 1, a = i * Math.PI / 5; if (i) s.push('L'); s.push(r * Math.sin(a), -r * Math.cos(a)); } s.push('Z'); return s; })();
SHAPES.dot = CIRCLE_L;
SHAPES.bubble = CIRCLE_L.concat(scaleShape(CIRCLE_L, 0.55, 0.55));
function scaleShape(sh, sx, sy) {
  const out = []; let axis = 0;
  for (const v of sh) { if (typeof v === 'string') { out.push(v); axis = 0; } else { out.push(axis % 2 ? v * sy : v * sx); axis++; } }
  return out;
}
/* moon at phase 0..1 (0 = new, .5 = full): lit limb + elliptical terminator, as cubic curves */
function moonShape(phase) {
  const k = Math.cos(phase * 2 * Math.PI), waxing = phase < 0.5, c = 0.5523;
  const limb = waxing ? 1 : -1, term = k * limb;
  return ['M', 0, -1, 'C', limb * c, -1, limb, -c, limb, 0, 'C', limb, c, limb * c, 1, 0, 1,
    'C', term * c, 1, term, c, term, 0, 'C', term, -c, term * c, -1, 0, -1, 'Z'];
}
function spiralShape(turns, steps) {
  const s = ['M', 0, 0];
  for (let i = 1; i <= steps; i++) { const t = i / steps, a = t * turns * 2 * Math.PI; s.push('L', t * Math.sin(a), -t * Math.cos(a)); }
  return s;
}
function scrollShape() {
  /* an S: two 1.25-turn spirals whose outer ends meet in the middle */
  const a = spiralShape(1.25, 36), pts = [], b = [];
  for (let i = 1; i < a.length; i += 3) pts.push([a[i], a[i + 1]]);
  pts.forEach((p, i) => b.push(i ? 'L' : 'M', p[0] * 0.5 - 0.5, p[1] * 0.5));
  for (let i = pts.length - 1; i >= 0; i--) b.push('L', -pts[i][0] * 0.5 + 0.5, -pts[i][1] * 0.5);
  return b;
}
const SPIRAL_L = spiralShape(1.6, 48), SCROLL_L = scrollShape();

/* local shape -> absolute path: centred on (ox, oy), local -y pointing at angle `deg`, scaled (sx along, sy across) */
function place(sh, ox, oy, deg, sx, sy) {
  const a = deg * Math.PI / 180, c = Math.cos(a), s = Math.sin(a);
  let d = '', axis = 0, x = 0;
  for (const v of sh) {
    if (typeof v === 'string') { d += v + ' '; axis = 0; continue; }
    if (axis % 2 === 0) x = v * sx;
    else { const y = v * sy; d += fx(ox + x * c - y * s) + ' ' + fx(oy + x * s + y * c) + ' '; }
    axis++;
  }
  return d;
}

/* ring motifs. stroke: drawn as lines (weight = line width). cont: one continuous shape (count = frequency) */
const MOTIFS = {
  band:     { label: 'Solid band', cont: true },
  frame:    { label: 'Polygon band', cont: true },
  rays:     { label: 'Sun rays' },
  spikes:   { label: 'Spikes' },
  teeth:    { label: 'Zigzag teeth', pairs: true },
  keys:     { label: 'Piano keys' },
  checker:  { label: 'Checkerboard' },
  petals:   { label: 'Petals' },
  scallops: { label: 'Scallops' },
  spiral:   { label: 'Hypno spiral' },
  dots:     { label: 'Dots' },
  bubbles:  { label: 'Bubbles' },
  diamonds: { label: 'Diamonds' },
  stars:    { label: 'Stars' },
  hearts:   { label: 'Hearts' },
  moons:    { label: 'Moon phases' },
  leaves:   { label: 'Leaves' },
  flames:   { label: 'Flames' },
  drops:    { label: 'Drops' },
  eyes:     { label: 'Eyes' },
  curls:    { label: 'Curls', stroke: true },
  scrolls:  { label: 'Scrolls', stroke: true },
  lace:     { label: 'Lace loops', stroke: true },
  chevrons: { label: 'Chevrons', stroke: true },
  zigzag:   { label: 'Zigzag line', stroke: true, cont: true },
  waves:    { label: 'Wave line', stroke: true, cont: true }
};
const MOTIF_IDS = Object.keys(MOTIFS);
/* the motifs a single star point can carry */
const POINT_MOTIFS = ['dot', 'bubble', 'star', 'heart', 'moon', 'leaf', 'flame', 'drop', 'diamond', 'eye', 'curl', 'scroll'];

function sector(r0, r1, a0, a1) {
  const large = (a1 - a0) > 180 ? 1 : 0;
  return 'M ' + pt(polar(r0, a0)) + ' L ' + pt(polar(r1, a0)) + ' A ' + fx(r1) + ' ' + fx(r1) + ' 0 ' + large + ' 1 ' + pt(polar(r1, a1)) +
    ' L ' + pt(polar(r0, a1)) + (r0 > 0.3 ? ' A ' + fx(r0) + ' ' + fx(r0) + ' 0 ' + large + ' 0 ' + pt(polar(r0, a0)) : '') + ' Z ';
}
/* shapes of one ring: { stroke, parts: [path data per instance] } */
function ringParts(ring) {
  const m = MOTIFS[ring.motif] || MOTIFS.rays;
  const n = Math.round(ring.n), r0 = ring.r0 * R, r1 = Math.max(ring.r1 * R, r0 + 0.5), rm = (r0 + r1) / 2, th = r1 - r0;
  const step = 360 / n, w = step * ring.size, rot = ring.rot, parts = [];
  /* largest motif radius that fits one cell at the ring's middle */
  const cell = Math.max(0.3, Math.min(th / 2, rm * Math.sin(Math.min(w, 179) * Math.PI / 360)));
  const ang = i => rot + i * step;
  switch (ring.motif) {
    case 'band': parts.push(annulusPath(r0, r1)); break;
    case 'frame': {
      const half = Math.PI / n, ro = r1 / Math.cos(half), ri = r0 / Math.cos(half);
      let d = '';
      [ro, ri].forEach((rr, j) => {
        if (j && r0 < 0.3) return;
        for (let i = 0; i < n; i++) d += (i ? 'L ' : 'M ') + pt(polar(rr, ang(i) + step / 2)) + ' ';
        d += 'Z ';
      });
      parts.push(d); break;
    }
    case 'rays': for (let i = 0; i < n; i++) parts.push('M ' + pt(polar(r0, ang(i) - w / 2)) + ' L ' + pt(polar(r1, ang(i))) + ' L ' + pt(polar(r0, ang(i) + w / 2)) + ' Z'); break;
    case 'spikes': for (let i = 0; i < n; i++) parts.push('M ' + pt(polar(r1, ang(i) - w / 2)) + ' L ' + pt(polar(r0, ang(i))) + ' L ' + pt(polar(r1, ang(i) + w / 2)) + ' Z'); break;
    case 'teeth':
      for (let i = 0; i < n; i++) {
        parts.push('M ' + pt(polar(r0, ang(i) - w / 2)) + ' L ' + pt(polar(r1, ang(i))) + ' L ' + pt(polar(r0, ang(i) + w / 2)) + ' Z');
        parts.push('M ' + pt(polar(r1, ang(i) + step / 2 - w / 2)) + ' L ' + pt(polar(r0, ang(i) + step / 2)) + ' L ' + pt(polar(r1, ang(i) + step / 2 + w / 2)) + ' Z');
      }
      break;
    case 'keys': for (let i = 0; i < n; i++) parts.push(sector(r0, r1, ang(i) - w / 2, ang(i) + w / 2)); break;
    case 'checker': for (let i = 0; i < n; i++) parts.push(i % 2 ? sector(rm, r1, ang(i) - w / 2, ang(i) + w / 2) : sector(r0, rm, ang(i) - w / 2, ang(i) + w / 2)); break;
    case 'petals':
      for (let i = 0; i < n; i++) {
        const a = ang(i);
        parts.push('M ' + pt(polar(r0, a)) + ' C ' + pt(polar(r0 + th * 0.35, a - w * 0.62)) + ' ' + pt(polar(r1 - th * 0.05, a - w * 0.28)) + ' ' + pt(polar(r1, a)) +
          ' C ' + pt(polar(r1 - th * 0.05, a + w * 0.28)) + ' ' + pt(polar(r0 + th * 0.35, a + w * 0.62)) + ' ' + pt(polar(r0, a)) + ' Z');
      }
      break;
    case 'scallops': {
      const rb = Math.max(r0, 1.5);
      for (let i = 0; i < n; i++) {
        const a = ang(i), rx = rb * Math.sin(w * Math.PI / 360);
        parts.push('M ' + pt(polar(rb, a - w / 2)) + ' A ' + fx(rx) + ' ' + fx(r1 - rb) + ' ' + fx(a) + ' 0 1 ' + pt(polar(rb, a + w / 2)) +
          ' A ' + fx(rb) + ' ' + fx(rb) + ' 0 0 0 ' + pt(polar(rb, a - w / 2)) + ' Z');
      }
      break;
    }
    case 'spiral': {
      const tw = ring.twist, S = 28;
      for (let i = 0; i < n; i++) {
        const a = ang(i);
        let d = '';
        for (let j = 0; j <= S; j++) { const u = j / S; d += (j ? 'L ' : 'M ') + pt(polar(r0 + th * u, a - w / 2 + tw * u)) + ' '; }
        d += 'A ' + fx(r1) + ' ' + fx(r1) + ' 0 0 1 ' + pt(polar(r1, a + w / 2 + tw)) + ' ';
        for (let j = S; j >= 0; j--) { const u = j / S; d += 'L ' + pt(polar(r0 + th * u, a + w / 2 + tw * u)) + ' '; }
        if (r0 > 0.3) d += 'A ' + fx(r0) + ' ' + fx(r0) + ' 0 0 0 ' + pt(polar(r0, a - w / 2)) + ' ';
        parts.push(d + 'Z');
      }
      break;
    }
    case 'dots': case 'bubbles': case 'stars': case 'hearts': case 'diamonds': case 'eyes': {
      const sh = { dots: SHAPES.dot, bubbles: SHAPES.bubble, stars: SHAPES.star, hearts: SHAPES.heart, diamonds: SHAPES.diamond, eyes: SHAPES.eye }[ring.motif];
      const sy = ring.motif === 'diamonds' ? th / 2 : ring.motif === 'eyes' ? cell * 0.8 : cell;
      for (let i = 0; i < n; i++) { const p = polar(rm, ang(i)); parts.push(place(sh, p.x, p.y, ang(i), cell, sy)); }
      break;
    }
    case 'moons': for (let i = 0; i < n; i++) { const p = polar(rm, ang(i)); parts.push(place(moonShape(n > 1 ? (i + 0.5) / n : 0.5), p.x, p.y, ang(i), cell, cell)); } break;
    case 'leaves': for (let i = 0; i < n; i++) { const p = polar(rm, ang(i)); parts.push(place(SHAPES.leaf, p.x, p.y, ang(i) + (i % 2 ? 32 : -32), cell * 0.75, th / 2)); } break;
    case 'flames': for (let i = 0; i < n; i++) { const p = polar(rm, ang(i)); parts.push(place(SHAPES.flame, p.x, p.y, ang(i), cell, th / 2)); } break;
    case 'drops': for (let i = 0; i < n; i++) { const p = polar(rm, ang(i)); parts.push(place(SHAPES.drop, p.x, p.y, ang(i), cell, th / 2)); } break;
    case 'curls': for (let i = 0; i < n; i++) { const p = polar(rm, ang(i)); parts.push(place(SPIRAL_L, p.x, p.y, ang(i), cell, cell)); } break;
    case 'scrolls': for (let i = 0; i < n; i++) { const p = polar(rm, ang(i)); parts.push(place(SCROLL_L, p.x, p.y, ang(i), cell, cell * 1.2)); } break;
    case 'lace': for (let i = 0; i < n; i++) { const p = polar(rm, ang(i)), rr = Math.max(0.5, th / 2 * ring.size); parts.push(place(CIRCLE_L, p.x, p.y, 0, rr, rr)); } break;
    case 'chevrons': for (let i = 0; i < n; i++) parts.push('M ' + pt(polar(r0, ang(i) - w / 2)) + ' L ' + pt(polar(r1, ang(i))) + ' L ' + pt(polar(r0, ang(i) + w / 2))); break;
    case 'zigzag': {
      let d = '';
      for (let j = 0; j <= n * 2; j++) d += (j ? 'L ' : 'M ') + pt(polar(j % 2 ? r1 : r0, rot + j * step / 2)) + ' ';
      parts.push(d + 'Z'); break;
    }
    case 'waves': {
      const S = Math.max(160, n * 16);
      let d = '';
      for (let j = 0; j <= S; j++) { const a = j / S * 360; d += (j ? 'L ' : 'M ') + pt(polar(rm + th / 2 * Math.sin(n * (a - rot) * Math.PI / 180), a)) + ' '; }
      parts.push(d + 'Z'); break;
    }
    default: break;
  }
  return { stroke: !!m.stroke, parts };
}

/* a single motif inside star point k (scaled to the point, turned to face outward) */
function pointMotifPath(k, type, size, rot) {
  const c = tipCentroid(k), s = size * Math.min(TIP_HALF_BASE * 0.62, TIP_HEIGHT * 0.36), deg = k * 45 + rot;
  const sh = { dot: SHAPES.dot, bubble: SHAPES.bubble, star: SHAPES.star, heart: SHAPES.heart, moon: moonShape(0.3), leaf: SHAPES.leaf,
    flame: SHAPES.flame, drop: SHAPES.drop, diamond: SHAPES.diamond, eye: SHAPES.eye, curl: SPIRAL_L, scroll: SCROLL_L }[type];
  if (!sh) return '';
  const tall = type === 'leaf' || type === 'flame' || type === 'drop';
  return place(sh, c.x, c.y, type === 'scroll' ? deg + 90 : deg, tall ? s * 0.7 : s, tall ? s * 1.25 : s);
}
function pointMotifIsStroke(type) { return type === 'curl' || type === 'scroll'; }

/* ── 06-model.js ── */
/* ── DESIGN MODEL ──
   state.designs[side] = {
     base:   { kind: 'pattern' | 'paint' | 'kaleido', url, name, scale, paint, folds, krot, kx, ky }
     wedges: 8 × { enabled, bgUrl, bgName, bgScale, rot }          (SF1 wedges, unchanged)
     points: { link: 'all' | 'alt' | 'each', items: 8 × PointFill }
     layers: [ ArtLayer | MandalaLayer | TextLayer ]                (bottom → top, max 12)
     logoPct, logoOp                                                (logo size % of star width, opacity %)
   } */
/* logo limits; codes without an opacity (made before it existed) keep the full-strength logo they showed */
const LOGO_MIN = 6, LOGO_MAX = 50, LOGO_OP_MIN = 50;
const MAX_LAYERS = 12, MAX_RINGS = 12, MAX_TEXT_LEN = 48;
const FONTS = ['Quantico', 'Bungee', 'Bungee Shade', 'Monoton', 'Righteous', 'Audiowide', 'Pacifico', 'Permanent Marker', 'Cinzel Decorative', 'Fredoka'];

function makeBase() { return { kind: 'pattern', url: '', name: '', scale: 100, paint: '#2a2520', folds: 8, krot: 0, kx: 0, ky: 0 }; }
function makeWedges() { const w = []; for (let i = 0; i < 8; i++) w.push({ enabled: false, bgUrl: '', bgName: '', bgScale: 100, rot: i * 45 }); return w; }
function makePoint() { return { kind: 'none', paint: '#e3a92b', url: '', name: '', scale: 60, motif: '', mpaint: '#fbf6ec', msize: 1, mrot: 0 }; }
function makePoints() { const items = []; for (let i = 0; i < 8; i++) items.push(makePoint()); return { link: 'all', items }; }
function makeDesign() { return { base: makeBase(), wedges: makeWedges(), points: makePoints(), layers: [], logoPct: 20, logoOp: LOGO_OP_MIN }; }
function makeArt() {
  return { type: 'art', url: '', name: '', cat: '', scale: 100, mode: 'single', rot: 0, x: 0, y: 0, flip: false,
    tint: 'hsb', hue: 0, sat: 100, bri: 50, paint: gradPaint('rainbow', 'sweep'), opacity: 1, hidden: false, locked: false };
}
function makeRing(motif) {
  return { motif: motif || 'rays', n: 16, r0: 0.3, r1: 0.5, rot: 0, size: 0.8, weight: 2.4, twist: 120, mode: 'one',
    fill: '#fbf6ec', fill2: '#e3a92b', bg: null, outline: null, hidden: false };
}
function makeMandala() { return { type: 'mandala', rings: [], rot: 0, opacity: 1, hidden: false, locked: false, sel: 0 }; }
function makeText() {
  return { type: 'text', text: 'FLOW', font: 'Bungee', size: 34, paint: '#fbf6ec', mode: 'arc', r: 0.62, flip: false, x: 0, y: 0, rot: 0,
    ls: 2, outline: null, hidden: false, locked: false };
}

const state = { numSides: 1, activeSide: 0, designs: [makeDesign(), makeDesign()] };
const ui = { tab: 'looks', sel: { kind: 'base' }, wedgeSel: -1, pointSel: 0, view: { trim: false, tips: false, uv: false, detail: false, zoom: 1 }, hide: {}, ringPart: 0, locks: {}, lib: {} };

function curDesign() { return state.designs[state.activeSide]; }
function selectedLayer() { const d = curDesign(); return ui.sel.kind === 'layer' ? d.layers[ui.sel.i] || null : null; }

/* ── HISTORY (undo / redo) ──
   Snapshot of everything that is "the design" (not the UI). Slider drags collapse into one step. */
const history = { past: [], future: [], last: '' };
function snapshot() { return JSON.stringify({ n: state.numSides, d: state.designs }); }
function commit() {
  const now = snapshot();
  if (now === history.last) return;
  if (history.last) history.past.push(history.last);
  if (history.past.length > 120) history.past.shift();
  history.future.length = 0;
  history.last = now;
  scheduleAutosave();
}
let commitTimer = 0;
function commitSoon() { clearTimeout(commitTimer); commitTimer = setTimeout(commit, 350); }
function restoreSnap(s) {
  const o = JSON.parse(s);
  state.numSides = o.n; state.designs = o.d;
  if (state.numSides === 1) state.activeSide = 0;
  history.last = s;
}
function undo() { clearTimeout(commitTimer); commit(); if (!history.past.length) return false; history.future.push(history.last); restoreSnap(history.past.pop()); scheduleAutosave(); return true; }
function redo() { if (!history.future.length) return false; history.past.push(history.last); restoreSnap(history.future.pop()); scheduleAutosave(); return true; }

/* ── DESIGN CODES ──
   SF2: base64url(JSON) of the full design (pattern keys, never images). Arrives in order emails and share
   links, so decoding accepts only known values, numbers in range and plain-text keys. SF1 still opens. */
function b64urlEncode(str) { return btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
function b64urlDecode(b64) {
  b64 = String(b64).replace(/\s+/g, '').replace(/-/g, '+').replace(/_/g, '/');
  while (b64.length % 4) b64 += '=';
  return decodeURIComponent(escape(atob(b64)));
}
function packPaint(p) { return isHex(p) ? p : { t: p.t, a: p.a, s: p.s }; }
function packDesign(d) {
  const o = { v: 2 };
  const b = d.base;
  o.b = b.kind === 'paint' ? { k: 'p', p: packPaint(b.paint) }
    : { k: b.kind === 'kaleido' ? 'k' : 'i', u: urlToKey(b.url), n: b.name, s: b.scale, f: b.folds, r: b.krot, x: Math.round(b.kx), y: Math.round(b.ky) };
  const w = d.wedges.map(x => x.enabled ? { u: urlToKey(x.bgUrl), n: x.bgName, s: x.bgScale, r: x.rot } : 0);
  if (w.some(Boolean)) o.w = w;
  if (d.points.items.some(p => p.kind !== 'none' || p.motif)) {
    o.p = { l: d.points.link, i: d.points.items.map(p => ({ k: p.kind, p: packPaint(p.paint), u: urlToKey(p.url), n: p.name, s: p.scale, m: p.motif, mp: packPaint(p.mpaint), ms: p.msize, mr: p.mrot })) };
  }
  o.L = d.layers.map(L => {
    if (L.type === 'art') return { t: 'a', u: urlToKey(L.url), n: L.name, s: L.scale, m: L.mode, r: L.rot, x: Math.round(L.x), y: Math.round(L.y), f: L.flip ? 1 : 0,
      c: L.tint, h: L.hue, sa: L.sat, br: L.bri, p: packPaint(L.paint), o: L.opacity, hd: L.hidden ? 1 : 0 };
    if (L.type === 'mandala') return { t: 'm', r: L.rot, o: L.opacity, hd: L.hidden ? 1 : 0, g: L.rings.map(g => ({ m: g.motif, n: g.n, a: g.r0, b: g.r1, r: g.rot, s: g.size,
      w: g.weight, tw: g.twist, md: g.mode, f: packPaint(g.fill), f2: packPaint(g.fill2), bg: g.bg ? packPaint(g.bg) : 0, ol: g.outline || 0, hd: g.hidden ? 1 : 0 })) };
    return { t: 't', x: L.text, ft: L.font, sz: L.size, p: packPaint(L.paint), md: L.mode, r: L.r, fl: L.flip ? 1 : 0, px: Math.round(L.x), py: Math.round(L.y),
      rt: L.rot, ls: L.ls, ol: L.outline || 0, hd: L.hidden ? 1 : 0 };
  });
  o.lg = d.logoPct; o.lo = d.logoOp;
  return o;
}
function designCode() {
  const st = { v: 2, ns: state.numSides, d: state.designs.slice(0, state.numSides).map(packDesign) };
  return 'SF2:' + b64urlEncode(JSON.stringify(st));
}

function unpackPaint(p, d) { return cleanPaint(p, d); }
function unpackOutline(o) { return o && typeof o === 'object' && isHex(o.c) ? { c: o.c.toLowerCase(), w: clampNum(o.w, 0.2, 8, 1) } : null; }
function unpackDesign(o) {
  const d = makeDesign();
  const b = o.b || {};
  if (b.k === 'p') { d.base.kind = 'paint'; d.base.paint = unpackPaint(b.p, '#2a2520'); }
  else {
    d.base.kind = b.k === 'k' ? 'kaleido' : 'pattern';
    d.base.url = keyToUrl(cleanKey(b.u)); d.base.name = cleanName(b.n); d.base.scale = clampNum(b.s, 10, 400, 100);
    d.base.folds = oneOf(Math.round(clampNum(b.f, 4, 24, 8)), [4, 6, 8, 12, 16, 24], 8); d.base.krot = norm360(b.r || 0);
    d.base.kx = clampNum(b.x, -VB, VB, 0); d.base.ky = clampNum(b.y, -VB, VB, 0);
  }
  (Array.isArray(o.w) ? o.w.slice(0, 8) : []).forEach((w, j) => {
    if (w) d.wedges[j] = { enabled: true, bgUrl: keyToUrl(cleanKey(w.u)), bgName: cleanName(w.n), bgScale: clampNum(w.s, 10, 400, 100), rot: w.r == null ? j * 45 : snap45(w.r) };
  });
  if (o.p && Array.isArray(o.p.i)) {
    d.points.link = oneOf(o.p.l, ['all', 'alt', 'each'], 'each');
    o.p.i.slice(0, 8).forEach((p, k) => {
      p = p || {};
      const q = makePoint();
      q.kind = oneOf(p.k, ['none', 'paint', 'pattern'], 'none'); q.paint = unpackPaint(p.p, q.paint);
      q.url = keyToUrl(cleanKey(p.u)); q.name = cleanName(p.n); q.scale = clampNum(p.s, 10, 400, 60);
      q.motif = oneOf(p.m, POINT_MOTIFS, ''); q.mpaint = unpackPaint(p.mp, q.mpaint); q.msize = clampNum(p.ms, 0.2, 1.6, 1); q.mrot = norm360(p.mr || 0);
      d.points.items[k] = q;
    });
  }
  d.layers = (Array.isArray(o.L) ? o.L.slice(0, MAX_LAYERS) : []).map(l => {
    l = l || {};
    if (l.t === 'a') {
      const L = makeArt();
      L.url = keyToUrl(cleanKey(l.u)); L.name = cleanName(l.n); L.scale = clampNum(l.s, 5, 400, 100); L.mode = l.m === 'repeat' ? 'repeat' : 'single';
      L.rot = norm360(l.r || 0); L.x = clampNum(l.x, -VB, VB, 0); L.y = clampNum(l.y, -VB, VB, 0); L.flip = !!l.f;
      L.tint = oneOf(l.c, ['hsb', 'paint', 'original'], 'hsb'); L.hue = clampNum(l.h, 0, 360, 0); L.sat = clampNum(l.sa, 0, 100, 100); L.bri = clampNum(l.br, 0, 200, 50);
      L.paint = unpackPaint(l.p, L.paint); L.opacity = clampNum(l.o, 0.05, 1, 1); L.hidden = !!l.hd;
      return L;
    }
    if (l.t === 'm') {
      const M = makeMandala();
      M.rot = norm360(l.r || 0); M.opacity = clampNum(l.o, 0.05, 1, 1); M.hidden = !!l.hd;
      M.rings = (Array.isArray(l.g) ? l.g.slice(0, MAX_RINGS) : []).map(g => {
        g = g || {};
        const r = makeRing(oneOf(g.m, MOTIF_IDS, 'rays'));
        r.n = Math.round(clampNum(g.n, 1, 96, 16)); r.r0 = clampNum(g.a, 0, 1.1, 0.3); r.r1 = clampNum(g.b, 0.02, 1.2, 0.5);
        if (r.r1 <= r.r0) r.r1 = Math.min(1.2, r.r0 + 0.02);
        r.rot = norm360(g.r || 0); r.size = clampNum(g.s, 0.05, 1, 0.8); r.weight = clampNum(g.w, 0.3, 12, 2.4); r.twist = clampNum(g.tw, -720, 720, 120);
        r.mode = oneOf(g.md, ['one', 'alt', 'spectrum'], 'one'); r.fill = unpackPaint(g.f, '#fbf6ec'); r.fill2 = unpackPaint(g.f2, '#e3a92b');
        r.bg = g.bg ? unpackPaint(g.bg, null) : null; r.outline = unpackOutline(g.ol); r.hidden = !!g.hd;
        return r;
      });
      return M;
    }
    if (l.t === 't') {
      const T = makeText();
      T.text = cleanText(l.x, MAX_TEXT_LEN); T.font = oneOf(l.ft, FONTS, 'Bungee'); T.size = clampNum(l.sz, 6, 120, 34); T.paint = unpackPaint(l.p, '#fbf6ec');
      T.mode = l.md === 'line' ? 'line' : 'arc'; T.r = clampNum(l.r, 0.15, 0.98, 0.62); T.flip = !!l.fl; T.x = clampNum(l.px, -VB, VB, 0); T.y = clampNum(l.py, -VB, VB, 0);
      T.rot = norm360(l.rt || 0); T.ls = clampNum(l.ls, -4, 30, 2); T.outline = unpackOutline(l.ol); T.hidden = !!l.hd;
      return T;
    }
    return null;
  }).filter(Boolean);
  d.logoPct = Math.round(clampNum(o.lg, LOGO_MIN, LOGO_MAX, 20));
  d.logoOp = Math.round(clampNum(o.lo == null ? 100 : o.lo, LOGO_OP_MIN, 100, 100));
  return d;
}
/* SF1 (the first StarForge): background + 8 wedges + up to 4 overlay layers + logo */
function unpackSF1(st) {
  const out = { numSides: clampNum(st.numSides, 1, 2, 1) === 2 ? 2 : 1, designs: [makeDesign(), makeDesign()] };
  (Array.isArray(st.designs) ? st.designs.slice(0, 2) : []).forEach((sd, i) => {
    sd = sd || {};
    const d = makeDesign();
    d.base.url = keyToUrl(cleanKey(sd.bg)); d.base.name = cleanName(sd.bgName); d.base.scale = clampNum(sd.bgScale, 10, 200, 100);
    const srcLayers = Array.isArray(sd.layers) ? sd.layers.slice(0, 4) : [sd];
    d.layers = srcLayers.map(sl => {
      sl = sl || {};
      const L = makeArt();
      L.url = keyToUrl(cleanKey(sl.ov)); L.name = cleanName(sl.ovName); L.scale = clampNum(sl.ovScale, 10, 200, 100);
      L.mode = sl.ovMode === 'repeat' ? 'repeat' : 'single'; L.rot = snap45(sl.ovRot);
      L.x = clampNum(sl.ovX, -VB, VB, 0); L.y = clampNum(sl.ovY, -VB, VB, 0);
      L.hue = clampNum(sl.hue, 0, 360, 0); L.sat = clampNum(sl.sat, 0, 100, 100); L.bri = clampNum(sl.bri, 0, 200, 50);
      L.tint = isColorOverlay(L.url) ? 'original' : 'hsb';
      return L;
    }).filter(L => L.url);
    d.logoPct = Math.round(clampNum(sd.logo, 10, 50, 20)); d.logoOp = 100;
    (Array.isArray(sd.wedges) ? sd.wedges.slice(0, 8) : []).forEach((w, j) => {
      if (w) d.wedges[j] = { enabled: true, bgUrl: keyToUrl(cleanKey(w.bg)), bgName: cleanName(w.name), bgScale: clampNum(w.scale, 10, 200, 100), rot: w.rot == null ? j * 45 : snap45(w.rot) };
    });
    out.designs[i] = d;
  });
  return out;
}
function decodeDesignCode(code) {
  const raw = String(code || '').trim();
  const m = raw.match(/^SF([12]):(.+)$/s);
  if (!m) throw new Error('A design code starts with SF1: or SF2:');
  const obj = JSON.parse(b64urlDecode(m[2]));
  if (m[1] === '1') return unpackSF1(obj);
  const out = { numSides: clampNum(obj.ns, 1, 2, 1) === 2 ? 2 : 1, designs: [makeDesign(), makeDesign()] };
  (Array.isArray(obj.d) ? obj.d.slice(0, 2) : []).forEach((dd, i) => { out.designs[i] = unpackDesign(dd || {}); });
  return out;
}
function applyDecoded(dec) {
  state.numSides = dec.numSides; state.designs = dec.designs; state.activeSide = 0;
  ui.sel = { kind: 'base' };
}
/* a side is ready when the whole star is covered: a background (pattern, colour or kaleidoscope) or all 8 wedges */
function sideProblem(i) {
  const d = state.designs[i], b = d.base;
  if (b.kind === 'paint' || b.url) return '';
  const filled = d.wedges.filter(w => w.enabled && w.bgUrl).length;
  if (filled === 8) return '';
  return 'Side ' + (i + 1) + ' needs a background: pick a pattern or a colour (or fill all 8 wedges).';
}

/* ── 07-render.js ── */
/* ── RENDERER ──
   renderSide() draws one side for every purpose, so screen, hand-off and print never drift:
     mode 'stage'   the live star (+ preview-only extras: trim coverage, guides, selection)
     mode 'thumb'   small previews (looks, sides)
     mode 'handoff' 800 px full-bleed image for the configurator (no star clip; it clips with its own star)
     mode 'print'   6000 px print file in StarForge Admin (star clip, no preview-only extras)
   Anything only for the screen sits in <g class="sf-preview-only"> and is stripped from exports. */
/* 'thumb' renders (look cards, side previews) draw images from the 256 px picker thumbnails instead of the
   1024 px previews: same keys under thumbs/ (make-thumbs.py). Admin and all other modes are unchanged. */
let THUMB_IMAGES = false;
function imgSrc(url) {
  if (THUMB_IMAGES && !ADMIN && url) {
    const m = /^(https?:\/\/[^/]+\/)previews\//.exec(url);
    if (m) return m[1] + 'thumbs/' + url.slice(m[0].length);
  }
  return srcFor(url);
}
function renderSide(d, opt) {
  opt = opt || {};
  const ctx = makeCtx(opt.idp || 'ff');
  const mode = opt.mode || 'stage';
  SWEEP_N = mode === 'print' ? 720 : mode === 'handoff' ? 360 : 96;
  THUMB_IMAGES = mode === 'thumb';
  /* hide: stage-only view toggles (Layers menu) so one part can be designed without the others in the way.
     Never passed for thumbs, hand-off or print, so a hidden part is always still printed. */
  const hide = (mode === 'stage' && opt.hide) || {};
  let body = '';
  if (!hide.background) { body += baseSvg(ctx, d.base); body += wedgesSvg(ctx, d.wedges); }
  if (!hide.points) body += pointsSvg(ctx, d.points);
  d.layers.forEach(L => { if (!L.hidden && !hide[L.type]) body += layerSvg(ctx, L); });
  if (!hide.logo) body += logoSvg(d);

  let content;
  if (mode === 'handoff') {
    content = '<rect x="0" y="0" width="' + VB + '" height="' + VB + '" fill="#2a2520"/>' + body;
  } else {
    const clip = ctx.id('star');
    ctx.defs.push('<clipPath id="' + clip + '"><path d="' + STAR_PATH + '"/></clipPath>');
    let uvAttr = '';
    if (opt.uv) { const f = ctx.id('uv'); ctx.defs.push(uvFilterDef(f)); uvAttr = ' filter="url(#' + f + ')"'; }
    content = '<path d="' + STAR_PATH + '" fill="#2a2520"/><g class="ff-art" clip-path="url(#' + clip + ')"><g' + uvAttr + '>' + body + '</g></g>';
  }
  if (mode === 'stage' || mode === 'thumb') {
    let pre = '';
    if (opt.tips) pre += '<path d="' + [0, 1, 2, 3, 4, 5, 6, 7].map(tipPath).join(' ') + '" fill="#fff" fill-opacity="0.8"/>';
    if (opt.trim) pre += trimCoverSvg();
    if (mode === 'stage') {
      pre += '<path d="' + STAR_PATH + '" fill="none" stroke="rgba(255,255,255,.15)" stroke-width="1.5"/>';
      if (d.wedges.some(w => w.enabled)) {
        for (let i = 0; i < 8; i++) {
          const p = polar(RIN, i * 45 - 22.5);
          pre += '<line x1="' + CX + '" y1="' + CY + '" x2="' + fx(p.x) + '" y2="' + fx(p.y) + '" stroke="rgba(255,255,255,.18)" stroke-width="0.6"/>';
        }
      }
      if (opt.select) pre += selectionSvg(d, opt.select);
    }
    if (pre) content += '<g class="sf-preview-only">' + pre + '</g>';
  }
  const vb = mode === 'handoff' ? (() => { const half = R / 0.92; return fx(CX - half) + ' ' + fx(CY - half) + ' ' + fx(2 * half) + ' ' + fx(2 * half); })() : '0 0 ' + VB + ' ' + VB;
  const size = opt.px ? ' width="' + opt.px + '" height="' + opt.px + '"' : '';
  return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="' + vb + '"' + size + '>' +
    (opt.fontCss ? '<style>' + opt.fontCss + '</style>' : '') + '<defs>' + ctx.defs.join('') + '</defs>' + content + '</svg>';
}

function imageTag(href, x, y, w, h, extra) {
  return '<image href="' + esc(href) + '" x="' + fx(x) + '" y="' + fx(y) + '" width="' + fx(w) + '" height="' + fx(h) + '"' + (extra || '') + '/>';
}
function patternDef(ctx, url, tile, x, y, transform) {
  const id = ctx.id('pt');
  ctx.defs.push('<pattern id="' + id + '" patternUnits="userSpaceOnUse" x="' + fx(x) + '" y="' + fx(y) + '" width="' + fx(tile) + '" height="' + fx(tile) + '"' +
    (transform ? ' patternTransform="' + transform + '"' : '') + '>' + imageTag(imgSrc(url), 0, 0, tile, tile, ' preserveAspectRatio="xMidYMid slice"') + '</pattern>');
  return id;
}

function baseSvg(ctx, b) {
  if (b.kind === 'paint') return paintParts(ctx, b.paint, ['M 0 0 H ' + VB + ' V ' + VB + ' H 0 Z'], 'fill', { cx: CX, cy: CY, r: R });
  if (!b.url) return '';
  if (b.kind === 'kaleido') return kaleidoSvg(ctx, b);
  const tile = VB * b.scale / 100;
  return '<rect x="0" y="0" width="' + VB + '" height="' + VB + '" fill="url(#' + patternDef(ctx, b.url, tile, CX - tile / 2, CY - tile / 2) + ')"/>';
}
/* kaleidoscope: one slice of the pattern, mirrored round the centre (folds slices, every other one flipped) */
function kaleidoSvg(ctx, b) {
  const folds = b.folds, seg = 360 / folds, tile = VB * b.scale / 100, far = VB;
  const pid = patternDef(ctx, b.url, tile, CX - tile / 2 + b.kx, CY - tile / 2 + b.ky, b.krot ? 'rotate(' + fx(b.krot) + ' ' + CX + ' ' + CY + ')' : '');
  const cid = ctx.id('kc'), sid = ctx.id('ks');
  ctx.defs.push('<clipPath id="' + cid + '"><path d="M ' + CX + ' ' + CY + ' L ' + pt(polar(far, -0.2)) + ' A ' + far + ' ' + far + ' 0 0 1 ' + pt(polar(far, seg + 0.2)) + ' Z"/></clipPath>');
  ctx.defs.push('<g id="' + sid + '" clip-path="url(#' + cid + ')"><rect x="' + (-VB) + '" y="' + (-VB) + '" width="' + (3 * VB) + '" height="' + (3 * VB) + '" fill="url(#' + pid + ')"/></g>');
  let out = '';
  for (let j = 0; j < folds; j++) {
    out += j % 2 === 0
      ? '<use href="#' + sid + '" xlink:href="#' + sid + '" transform="rotate(' + fx(j * seg) + ' ' + CX + ' ' + CY + ')"/>'
      : '<use href="#' + sid + '" xlink:href="#' + sid + '" transform="rotate(' + fx((j + 1) * seg) + ' ' + CX + ' ' + CY + ') translate(' + CX + ' 0) scale(-1 1) translate(' + (-CX) + ' 0)"/>';
  }
  return out;
}
function wedgesSvg(ctx, wedges) {
  let out = '';
  wedges.forEach((w, i) => {
    if (!w.enabled || !w.bgUrl) return;
    const tile = VB * w.bgScale / 100;
    const pid = patternDef(ctx, w.bgUrl, tile, CX - tile / 2, CY - tile / 2, 'rotate(' + snap45(w.rot) + ' ' + CX + ' ' + CY + ')');
    const cid = ctx.id('wc');
    ctx.defs.push('<clipPath id="' + cid + '"><path d="' + wedgeClipPath(i) + '"/></clipPath>');
    out += '<g clip-path="url(#' + cid + ')"><rect x="0" y="0" width="' + VB + '" height="' + VB + '" fill="url(#' + pid + ')"/></g>';
  });
  return out;
}
const POINT_BOX = { cx: CX, cy: CY, r: R, r0: RIN_APOTHEM };
function pointsSvg(ctx, pts) {
  let out = '';
  pts.items.forEach((p, k) => {
    if (p.kind === 'none' && !p.motif) return;
    const tip = tipPath(k);
    if (p.kind === 'paint') out += paintParts(ctx, p.paint, [tip], 'fill', POINT_BOX);
    else if (p.kind === 'pattern' && p.url) {
      const c = tipCentroid(k), tile = VB * p.scale / 100;
      out += '<path d="' + tip + '" fill="url(#' + patternDef(ctx, p.url, tile, c.x - tile / 2, c.y - tile / 2, 'rotate(' + (k * 45) + ' ' + fx(c.x) + ' ' + fx(c.y) + ')') + ')"/>';
    }
    if (p.motif) {
      const cid = ctx.id('tc');
      ctx.defs.push('<clipPath id="' + cid + '"><path d="' + tip + '"/></clipPath>');
      const stroke = pointMotifIsStroke(p.motif);
      out += '<g clip-path="url(#' + cid + ')">' + paintParts(ctx, p.mpaint, [pointMotifPath(k, p.motif, p.msize, p.mrot)], stroke ? 'stroke' : 'fill', POINT_BOX, 2.6) + '</g>';
    }
  });
  return out;
}
/* several shapes painted with one paint (a gradient spans all of them, like one piece of fabric) */
function paintParts(ctx, p, parts, kind, box, w, extra) {
  const ref = paintRef(ctx, p, box);
  const style = kind === 'stroke'
    ? ' fill="none" stroke-width="' + fx(w || 2) + '" stroke-linecap="round" stroke-linejoin="round"'
    : ' fill-rule="evenodd"';
  const paths = parts.map(d => '<path d="' + d + '"/>').join('');
  if (!ref.sweep) return '<g' + style + (kind === 'stroke' ? ' stroke="' + ref.fill + '"' : ' fill="' + ref.fill + '"') + (extra || '') + '>' + paths + '</g>';
  const white = '<g' + style + (kind === 'stroke' ? ' stroke="#fff"' : ' fill="#fff"') + '>' + paths + '</g>';
  return maskedSweep(ctx, p, p.a || 0, white) + (extra ? '<g fill="none"' + extra + '>' + paths + '</g>' : '');
}
function ringSvg(ctx, g) {
  if (g.hidden) return '';
  const geo = ringParts(g);
  if (!geo.parts.length) return '';
  const r0 = g.r0 * R, r1 = g.r1 * R, box = { cx: CX, cy: CY, r: Math.max(r1, 1), r0 };
  const kind = geo.stroke ? 'stroke' : 'fill', w = g.weight;
  const ol = (!geo.stroke && g.outline) ? ' stroke="' + g.outline.c + '" stroke-width="' + fx(g.outline.w) + '" stroke-linejoin="round"' : '';
  let out = g.bg ? paintParts(ctx, g.bg, [annulusPath(r0, r1)], 'fill', box) : '';
  if (g.mode === 'one' || geo.parts.length === 1) out += paintParts(ctx, g.fill, geo.parts, kind, box, w, ol);
  else if (g.mode === 'alt') {
    out += paintParts(ctx, g.fill, geo.parts.filter((x, i) => i % 2 === 0), kind, box, w, ol);
    out += paintParts(ctx, g.fill2, geo.parts.filter((x, i) => i % 2 === 1), kind, box, w, ol);
  } else {
    const n = geo.parts.length;
    out += geo.parts.map((d, i) => {
      const c = samplePaint(g.fill, i / n, n);
      return kind === 'stroke'
        ? '<path d="' + d + '" fill="none" stroke="' + c + '" stroke-width="' + fx(w) + '" stroke-linecap="round" stroke-linejoin="round"/>'
        : '<path d="' + d + '" fill="' + c + '" fill-rule="evenodd"' + ol + '/>';
    }).join('');
  }
  return out;
}
function layerSvg(ctx, L) {
  const op = L.opacity < 1 ? ' opacity="' + fx(L.opacity) + '"' : '';
  if (L.type === 'art') return artSvg(ctx, L, op);
  if (L.type === 'mandala') {
    const rings = L.rings.map(g => ringSvg(ctx, g)).join('');
    return rings ? '<g' + op + (L.rot ? ' transform="rotate(' + fx(L.rot) + ' ' + CX + ' ' + CY + ')"' : '') + '>' + rings + '</g>' : '';
  }
  if (L.type === 'text') return textSvg(ctx, L, op);
  return '';
}
function whiteAlphaFilter(ctx) {
  if (!ctx.whiteId) {
    ctx.whiteId = ctx.id('wa');
    ctx.defs.push('<filter id="' + ctx.whiteId + '" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 1 0"/></filter>');
  }
  return ctx.whiteId;
}
function artSvg(ctx, L, op) {
  if (!L.url) return '';
  const size = 360 * (L.scale || 100) / 100, ocx = CX + (L.x || 0), ocy = CY + (L.y || 0), rot = L.rot || 0, href = imgSrc(L.url);
  let img;
  if (L.mode === 'repeat') {
    /* seamless tiles, origin at the dragged point, turned about it */
    const pid = ctx.id('op');
    ctx.defs.push('<pattern id="' + pid + '" patternUnits="userSpaceOnUse" x="' + fx(ocx) + '" y="' + fx(ocy) + '" width="' + fx(size) + '" height="' + fx(size) +
      '" patternTransform="rotate(' + fx(rot) + ' ' + fx(ocx) + ' ' + fx(ocy) + ')">' +
      imageTag(href, 0, 0, size, size, ' preserveAspectRatio="xMidYMid meet"' + (L.flip ? ' transform="translate(' + fx(size) + ' 0) scale(-1 1)"' : '')) + '</pattern>');
    img = '<rect x="' + (-VB) + '" y="' + (-VB) + '" width="' + (3 * VB) + '" height="' + (3 * VB) + '" fill="url(#' + pid + ')"/>';
  } else {
    const flip = L.flip ? ' translate(' + fx(ocx) + ' 0) scale(-1 1) translate(' + fx(-ocx) + ' 0)' : '';
    img = imageTag(href, ocx - size / 2, ocy - size / 2, size, size, ' preserveAspectRatio="xMidYMid meet" transform="rotate(' + fx(rot) + ' ' + fx(ocx) + ' ' + fx(ocy) + ')' + flip + '"');
  }
  if (L.tint === 'original' || isColorOverlay(L.url)) return '<g' + op + '>' + img + '</g>';
  if (L.tint === 'paint') {
    /* the line art becomes a stencil: any paint (gradients too) shows through it */
    const mid = ctx.id('am');
    ctx.defs.push('<mask id="' + mid + '" maskUnits="userSpaceOnUse" x="' + (-VB) + '" y="' + (-VB) + '" width="' + (3 * VB) + '" height="' + (3 * VB) + '"><g filter="url(#' + whiteAlphaFilter(ctx) + ')">' + img + '</g></mask>');
    if (L.paint.t === 'sweep') return '<g' + op + ' mask="url(#' + mid + ')">' + sweepFan(L.paint, L.paint.a || 0) + '</g>';
    const ref = paintRef(ctx, L.paint, { cx: CX, cy: CY, r: R });
    return '<g' + op + '><rect x="' + (-VB) + '" y="' + (-VB) + '" width="' + (3 * VB) + '" height="' + (3 * VB) + '" fill="' + ref.fill + '" mask="url(#' + mid + ')"/></g>';
  }
  const fid = ctx.id('cz');
  ctx.defs.push('<filter id="' + fid + '" color-interpolation-filters="sRGB"><feFlood flood-color="' + hsbToHsl(L.hue, L.sat, L.bri) + '" result="flood"/><feComposite in="flood" in2="SourceAlpha" operator="in"/></filter>');
  return '<g' + op + ' filter="url(#' + fid + ')">' + img + '</g>';
}
function textSvg(ctx, T, op) {
  if (!T.text) return '';
  ctx.fonts[T.font] = (ctx.fonts[T.font] || '') + T.text;
  const fam = esc("'" + T.font + "', sans-serif");
  const ol = T.outline ? ' stroke="' + T.outline.c + '" stroke-width="' + fx(T.outline.w) + '" paint-order="stroke" stroke-linejoin="round"' : '';
  const attrs = ' font-family="' + fam + '" font-size="' + fx(T.size) + '" letter-spacing="' + fx(T.ls) + '" text-anchor="middle"';
  let inner, pos = '';
  if (T.mode === 'arc') {
    const r = T.r * R, pid = ctx.id('tp');
    ctx.defs.push('<path id="' + pid + '" d="M ' + fx(CX - r) + ' ' + CY + ' A ' + fx(r) + ' ' + fx(r) + ' 0 0 ' + (T.flip ? 0 : 1) + ' ' + fx(CX + r) + ' ' + CY + '"/>');
    inner = '<textPath href="#' + pid + '" xlink:href="#' + pid + '" startOffset="50%" dominant-baseline="middle">' + esc(T.text) + '</textPath>';
  } else {
    inner = esc(T.text); pos = ' x="' + CX + '" y="' + CY + '" dominant-baseline="middle"';
  }
  const tr = ' transform="translate(' + fx(T.x) + ' ' + fx(T.y) + ') rotate(' + fx(T.rot) + ' ' + CX + ' ' + CY + ')"';
  const ref = paintRef(ctx, T.paint, { cx: CX, cy: CY, r: R });
  if (!ref.sweep) return '<g' + op + tr + '><text' + attrs + pos + ' fill="' + ref.fill + '"' + ol + '>' + inner + '</text></g>';
  const white = '<text' + attrs + pos + ' fill="#fff">' + inner + '</text>';
  return '<g' + op + tr + '>' + (ol ? '<text' + attrs + pos + ' fill="none"' + ol + '>' + inner + '</text>' : '') + maskedSweep(ctx, T.paint, T.paint.a || 0, white) + '</g>';
}
/* every star carries the Brain Plague Designs logo in the centre */
function logoSvg(d) {
  const w = 2 * R * clampNum(d.logoPct, LOGO_MIN, LOGO_MAX, 20) / 100, h = w * LOGO_ASPECT;
  const op = clampNum(d.logoOp, LOGO_OP_MIN, 100, 100);
  return imageTag(imgSrc(keyToUrl(LOGO_KEY)), CX - w / 2, CY - h / 2, w, h, ' class="sf-logo" preserveAspectRatio="xMidYMid meet"' + (op < 100 ? ' opacity="' + op / 100 + '"' : ''));
}

/* blacklight (approximate): dyes go dark violet, bright and neon colours stay lit and bloom */
function uvFilterDef(id) {
  return '<filter id="' + id + '" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB">' +
    '<feColorMatrix in="SourceGraphic" type="matrix" result="dim" values="0.26 0 0 0 0.02  0 0.22 0 0 0.01  0 0 0.38 0 0.06  0 0 0 1 0"/>' +
    '<feColorMatrix in="SourceGraphic" type="saturate" values="1.9" result="sat"/>' +
    '<feComponentTransfer in="sat" result="lit"><feFuncR type="gamma" amplitude="1.25" exponent="3.4" offset="0"/><feFuncG type="gamma" amplitude="1.2" exponent="3.4" offset="0"/><feFuncB type="gamma" amplitude="1.35" exponent="3" offset="0"/></feComponentTransfer>' +
    '<feGaussianBlur in="lit" stdDeviation="2.4" result="bloom"/>' +
    '<feBlend in="lit" in2="dim" mode="screen" result="base"/><feBlend in="bloom" in2="base" mode="screen"/></filter>';
}

/* trim coverage (screen only, never printed): the two square bindings over the print, so customers see
   what the binding will hide. A plain dark band with a faint centre line; colours are picked in the configurator. */
function trimCoverSvg() {
  const tw = trimStrokeW();
  let out = '<g class="ff-trim">';
  [SQUARE.bs, SQUARE.ts].forEach(sq => {
    const d = 'M ' + sq.map(pt).join(' L ') + ' Z';
    out += '<path d="' + d + '" fill="none" stroke="#1c1c1c" stroke-opacity="0.92" stroke-width="' + fx(tw) + '" stroke-linejoin="miter"/>' +
      '<path d="' + d + '" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="' + fx(0.35 * K) + '" stroke-dasharray="' + fx(1.6 * K) + ' ' + fx(1.3 * K) + '"/>';
  });
  return out + '</g>';
}

/* what is selected, drawn as a dashed outline on the stage */
function selectionSvg(d, sel) {
  const dash = ' fill="none" stroke="#fbf6ec" stroke-width="1.4" stroke-dasharray="5 4" vector-effect="non-scaling-stroke"';
  const halo = ' fill="none" stroke="#1e1209" stroke-width="3" stroke-opacity=".55" vector-effect="non-scaling-stroke"';
  let d2 = '';
  if (sel.kind === 'point') d2 = sel.ks.map(tipPath).join(' ');
  else if (sel.kind === 'wedge') d2 = wedgeClipPath(sel.i);
  else if (sel.kind === 'ring') {
    const L = d.layers[sel.layer], g = L && L.rings[sel.ring];
    if (g && g.mode === 'alt' && sel.part != null) {
      /* Alternate: outline only the shapes A or B paints, turned with the mandala */
      const parts = ringParts(g).parts.filter((x, i) => i % 2 === sel.part);
      if (parts.length > 1) {
        const p = parts.join(' '), t = L.rot ? ' transform="rotate(' + fx(L.rot) + ' ' + CX + ' ' + CY + ')"' : '';
        return '<g' + t + '><path d="' + p + '"' + halo + '/><path d="' + p + '"' + dash + '/></g>';
      }
    }
    if (g) d2 = annulusPath(g.r0 * R, g.r1 * R);
  } else if (sel.kind === 'art') {
    const L = d.layers[sel.layer];
    if (L && L.url && L.mode !== 'repeat') {
      const s = 360 * L.scale / 100, x = CX + L.x - s / 2, y = CY + L.y - s / 2;
      d2 = 'M ' + fx(x) + ' ' + fx(y) + ' h ' + fx(s) + ' v ' + fx(s) + ' h ' + fx(-s) + ' Z';
    }
  }
  return d2 ? '<path d="' + d2 + '"' + halo + '/><path d="' + d2 + '"' + dash + '/>' : '';
}

/* ── 08-export.js ── */
/* ── EXPORT ──
   An <svg> drawn into a canvas can't load outside files, so before rasterising every image is
   inlined as a data URL (fetched with ?cors=1: the thumbnails' <img> loads are cached without CORS
   headers and the browser would refuse to reuse them) and text fonts are embedded as @font-face. */
function fetchAsDataURL(url) {
  const u = url + (url.indexOf('?') < 0 ? '?' : '&') + 'cors=1';
  return fetch(u, { mode: 'cors' }).then(r => { if (!r.ok) throw new Error(r.status); return r.blob(); }).then(blobToDataURL);
}
function blobToDataURL(b) {
  return new Promise((resolve, reject) => { const fr = new FileReader(); fr.onloadend = () => resolve(fr.result); fr.onerror = reject; fr.readAsDataURL(b); });
}
function unescAttr(s) { return s.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'); }
async function inlineImages(svg) {
  const urls = new Set();
  svg.replace(/<image [^>]*?href="([^"]+)"/g, (m, u) => { if (u.indexOf('data:') !== 0) urls.add(u); return m; });
  const map = {};
  await Promise.all(Array.from(urls).map(u => fetchAsDataURL(unescAttr(u)).then(d => { map[u] = d; }).catch(() => {})));
  return svg.replace(/(<image [^>]*?href=")([^"]+)(")/g, (m, a, u, b) => map[u] ? a + map[u] + b : m);
}
function fontsOf(d) {
  const f = {};
  d.layers.forEach(L => { if (L.type === 'text' && !L.hidden && L.text) f[L.font] = (f[L.font] || '') + L.text; });
  return f;
}
/* Google Fonts: one css2 request per family, subset to the letters used, files inlined */
async function fontCssFor(fonts) {
  const fams = Object.keys(fonts);
  const parts = await Promise.all(fams.map(async fam => {
    const chars = Array.from(new Set(Array.from(fonts[fam] + ' '))).join('');
    const url = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(fam).replace(/%20/g, '+') + '&text=' + encodeURIComponent(chars);
    let css = await (await fetch(url)).text();
    const files = css.match(/url\((https:[^)]+)\)/g) || [];
    for (const f of files) {
      const src = f.slice(4, -1);
      const data = await fetch(src).then(r => r.blob()).then(blobToDataURL);
      css = css.split(src).join(data);
    }
    return css;
  }));
  return parts.join('\n');
}
function rasterize(svg, w, h) {
  h = h || w;
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml;charset=utf-8' }));
    const img = new Image();
    img.onload = () => {
      const c = document.createElement('canvas'); c.width = w; c.height = h;
      c.getContext('2d').drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(url); resolve(c);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('The design could not be drawn. Try again in a moment.')); };
    img.src = url;
  });
}
/* one side to a canvas: mode 'print' (star-shaped, transparent outside) or 'handoff' (full bleed) */
async function sideCanvas(sideIdx, px, mode) {
  const d = state.designs[sideIdx], fonts = fontsOf(d);
  const fontCss = Object.keys(fonts).length ? await fontCssFor(fonts).catch(() => '') : '';
  const svg = await inlineImages(renderSide(d, { idp: 'x' + sideIdx + mode[0], mode, px, fontCss }));
  return rasterize(svg, px);
}
function canvasBlob(c, type, q) { return new Promise((resolve, reject) => c.toBlob(b => b ? resolve(b) : reject(new Error('render failed')), type || 'image/png', q)); }

/* ── HAND-OFF to the configurator ──
   sessionStorage 'starforge-handoff' (name kept on purpose: the configurator reads it):
   { designCode, numSides, side1Image, side2Image (800 px previews, never printable) }
   Trim, thread and their colours are chosen in the configurator, not here. */
const HANDOFF_PX = 800;
async function handoffToConfigurator() {
  const problems = [];
  for (let i = 0; i < state.numSides; i++) { const p = sideProblem(i); if (p) problems.push(p); }
  if (problems.length) {
    showGate(problems.join(' '));
    const first = +problems[0].charAt(5) - 1;
    if (first !== state.activeSide) setSide(first);
    setTab('background');
    return;
  }
  showGate('');
  const busy = showBusy('Preparing your design…');
  try {
    const images = [];
    for (let i = 0; i < state.numSides; i++) {
      busy('Rendering side ' + (i + 1) + '…');
      images.push((await sideCanvas(i, HANDOFF_PX, 'handoff')).toDataURL('image/jpeg', 0.92));
    }
    const handoff = {
      designCode: designCode(), numSides: state.numSides,
      side1Image: images[0] || '', side2Image: images[1] || '',
      timestamp: Date.now()
    };
    sessionStorage.setItem('starforge-handoff', JSON.stringify(handoff));
    saveDraftNow();
    busy('Opening size & price…');
    setTimeout(() => { window.location.href = CONFIGURATOR_URL; }, 300);
  } catch (e) {
    hideBusy();
    showGate(/quota/i.test(String(e && e.name) + String(e && e.message)) ? 'Your browser ran out of room to carry the design over. Close other tabs and try again.' : (e.message || 'Something went wrong preparing the design. Try again.'));
  }
}

/* ── SHARE IMAGE (customers): a 1080 × 1350 card with the star at 800 px and the watermark ── */
async function saveShareImage() {
  const busy = showBusy('Making your image…');
  try {
    const star = await sideCanvas(state.activeSide, 800, 'print');
    const W = 1080, H = 1350, c = document.createElement('canvas'); c.width = W; c.height = H;
    const g = c.getContext('2d');
    const bg = g.createLinearGradient(0, 0, 0, H); bg.addColorStop(0, '#2a1a0c'); bg.addColorStop(1, '#140c05');
    g.fillStyle = bg; g.fillRect(0, 0, W, H);
    g.drawImage(star, (W - 800) / 2, 110, 800, 800);
    g.save(); g.globalAlpha = 0.16; g.fillStyle = '#ffffff'; g.font = '700 26px Inter, Arial, sans-serif';
    g.translate(W / 2, 510); g.rotate(-24 * Math.PI / 180);
    for (let y = -520; y <= 520; y += 120) for (let x = -760; x <= 760; x += 330) g.fillText('brainplaguedesigns.com', x - 140, y);
    g.restore();
    g.fillStyle = '#fbf6ec'; g.textAlign = 'center';
    g.font = '700 54px Quantico, Inter, Arial, sans-serif'; g.fillText('Designed in FlowForge', W / 2, 1030);
    g.fillStyle = '#e3a92b'; g.font = '700 40px Quantico, Inter, Arial, sans-serif'; g.fillText('#ForgeYourStar', W / 2, 1100);
    g.fillStyle = '#cdbb9e'; g.font = '400 30px Inter, Arial, sans-serif'; g.fillText('Design yours: brainplaguedesigns.com/pages/flowforge', W / 2, 1180);
    const blob = await canvasBlob(c, 'image/png');
    const file = new File([blob], 'my-flowstar.png', { type: 'image/png' });
    hideBusy();
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try { await navigator.share({ files: [file], title: 'My FlowStar', text: 'I designed this in FlowForge #ForgeYourStar' }); return; } catch (e) { if (e && e.name === 'AbortError') return; }
    }
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'my-flowstar.png'; a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    toast('Image saved');
  } catch (e) { hideBusy(); toast('Could not make the image: ' + (e.message || 'try again')); }
}

/* ── ADMIN: print files (6000 px) into Z:\BRAIN PLAGUE DESIGNS\FlowStar Print Files\<date>_<order>_<name>\ ── */
async function exportAllToFolder(btn) {
  if (!ADMIN) return;
  const clean = v => (v || '').trim().replace(/\s+/g, '-').replace(/[^a-zA-Z0-9_-]/g, '');
  const order = clean(adminVal('order-id')), name = clean(adminVal('customer-name'));
  const parts = [new Date().toISOString().slice(0, 10)];
  if (order) parts.push(order);
  if (name) parts.push(name);
  if (!order && !name) parts.push(new Date().toTimeString().slice(0, 8).replace(/:/g, ''));
  const folder = parts.join('_');
  const save = (file, body) => fetch('/save-print?folder=' + encodeURIComponent(folder) + '&file=' + encodeURIComponent(file),
    { method: 'POST', body, headers: { 'X-StarForge-Admin': '1' } }).then(r => r.json().then(j => { if (!r.ok) throw new Error(j.error || r.status); return j; }));
  if (btn) { btn.disabled = true; btn.textContent = 'Exporting…'; }
  try {
    for (let i = 0; i < state.numSides; i++) await save('side' + (i + 1) + '_6000px.png', await canvasBlob(await sideCanvas(i, 6000, 'print')));
    const sheet = designCode() + '\n\nTrim & thread: see the configurator spec in the order email.\n';
    const j = await save('design-code.txt', sheet);
    alert('Saved to: ' + j.folder);
  } catch (e) { alert('Export failed: ' + e.message); }
  if (btn) { btn.disabled = false; btn.textContent = 'Export all sides to print folder'; }
}
async function exportOnePNG() {
  if (!ADMIN) return;
  const blob = await canvasBlob(await sideCanvas(state.activeSide, 6000, 'print'));
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
  a.download = ['FlowForge', adminVal('order-id').replace(/[^a-zA-Z0-9_-]/g, ''), 'side' + (state.activeSide + 1), new Date().toISOString().slice(0, 10), '6000px'].filter(Boolean).join('_') + '.png';
  a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 4000);
}
function adminVal(id) { const el = ROOT.querySelector('[data-admin="' + id + '"]'); return el ? el.value : ''; }

/* ── SHARE LINK: the design code in the address (#ff=SF2:…); opening it restores the design ── */
function shareLink() { return location.origin + location.pathname + '#ff=' + designCode(); }
async function copyShareLink() {
  const link = shareLink();
  try { await navigator.clipboard.writeText(link); toast('Link copied. Anyone with it can open this design.'); }
  catch (e) { window.prompt('Copy this link:', link); }
}

/* ── AUTOSAVE (this browser only) ── */
const DRAFT_KEY = 'flowforge:draft';
let autosaveTimer = 0;
function scheduleAutosave() { clearTimeout(autosaveTimer); autosaveTimer = setTimeout(saveDraftNow, 800); }
function saveDraftNow() { try { localStorage.setItem(DRAFT_KEY, JSON.stringify({ code: designCode(), t: Date.now() })); } catch (e) {} }
function readDraft() {
  try {
    const o = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null');
    return o && o.code && Date.now() - o.t < 60 * 24 * 3600 * 1000 ? o.code : '';
  } catch (e) { return ''; }
}

/* ── 09-library.js ── */
/* ── PATTERN LIBRARY ──
   ~49,000 backgrounds and ~2,900 overlays, grouped Theme → Category (catalog/themes.json). The manifests
   are big, so each loads the first time it is needed. Saved and recent picks live in this browser. */
const LIB = { bg: null, ov: null, loading: {} };
function loadManifest(which) {
  if (LIB[which]) return Promise.resolve(LIB[which]);
  if (LIB.loading[which]) return LIB.loading[which];
  const name = which === 'bg' ? 'studio-backgrounds-manifest-v2.json' : 'studio-overlays-manifest-v2.json';
  LIB.loading[which] = fetch(MANIFEST_BASE + '/' + name)
    .then(r => { if (!r.ok) throw new Error('library ' + r.status); return r.json(); })
    .then(m => { LIB[which] = m; return m; })
    .catch(e => { delete LIB.loading[which]; throw e; });
  return LIB.loading[which];
}
function fileUrl(cat, file) { return cat.baseUrl + file.file.split('/').map(encodeURIComponent).join('/'); }
/* picker tiles show 256 px thumbnails (CDN thumbs/<key>, made by make-thumbs.py) instead of the 1024 px
   previews; a missing thumbnail falls back to the preview once. Admin mode serves local previews only. */
function thumbImg(url, alt) {
  const m = !ADMIN && /^(https?:\/\/[^/]+\/)previews\//.exec(url || '');
  const img = h('img', { src: m ? m[1] + 'thumbs/' + url.slice(m[0].length) : (url || ''), alt: alt, loading: 'lazy', decoding: 'async' });
  if (m) img.addEventListener('error', () => { img.src = url; }, { once: true });
  return img;
}
function catById(which, id) { const m = LIB[which]; return m ? m.categories.find(c => c.id === id) || null : null; }
function themesOf(m) {
  const order = m.themes || [], groups = {};
  m.categories.forEach(c => { const t = c.theme || 'More'; (groups[t] = groups[t] || []).push(c); });
  return Object.keys(groups).sort((a, b) => { const i = order.indexOf(a), j = order.indexOf(b); return (i < 0 ? 999 : i) - (j < 0 ? 999 : j); })
    .map(t => ({ name: t, cats: groups[t] }));
}

function lsGet(k, d) { try { const v = JSON.parse(localStorage.getItem(k) || 'null'); return v == null ? d : v; } catch (e) { return d; } }
function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
function savedList(which) { return lsGet('flowforge:saved:' + which, []); }
function isSaved(which, url) { return savedList(which).some(x => x.u === url); }
function toggleSaved(which, url, name) {
  let l = savedList(which);
  if (l.some(x => x.u === url)) l = l.filter(x => x.u !== url); else l.unshift({ u: url, n: name });
  lsSet('flowforge:saved:' + which, l.slice(0, 120));
}
function pushRecent(which, url, name) {
  const l = lsGet('flowforge:recent:' + which, []).filter(x => x.u !== url);
  l.unshift({ u: url, n: name });
  lsSet('flowforge:recent:' + which, l.slice(0, 24));
}

/* Library browser. opts: { which: 'bg'|'ov', current: url, onPick(url, name, cat) }.
   One page at a time (12: 3 x 4 on phones, 4 x 3 above), turned with the arrows or a sideways swipe, so the
   panel never grows as the customer browses. */
const PAGE = 12;
function libraryBrowser(opts) {
  const which = opts.which, st = ui.lib[which] = ui.lib[which] || { view: 'themes', theme: '', cat: '', q: '', pg: 0 };
  const box = h('div', { class: 'ff-lib' });
  const search = h('input', { type: 'search', class: 'ff-input', placeholder: which === 'bg' ? 'Search 49,000 patterns: galaxy, mandala, neon…' : 'Search overlays: mushrooms, eyes, spirals…', value: st.q,
    'aria-label': 'Search the library' });
  const body = h('div', { class: 'ff-lib-body' });
  box.append(search, body);
  let qTimer = 0;
  search.addEventListener('input', () => { clearTimeout(qTimer); qTimer = setTimeout(() => { st.q = search.value.trim(); st.pg = 0; draw(); }, 180); });

  function crumb(label, fn) { return h('button', { type: 'button', class: 'ff-crumb', onclick: fn }, '‹ ' + label); }
  function thumbGrid(items, cat) {
    const grid = h('div', { class: 'ff-thumbs' + (which === 'ov' ? ' is-ov' : '') });
    const pages = Math.max(1, Math.ceil(items.length / PAGE));
    st.pg = Math.max(0, Math.min(pages - 1, st.pg || 0));
    const start = st.pg * PAGE;
    items.slice(start, start + PAGE).forEach(it => {
      const url = it.u, name = it.n;
      const b = h('button', { type: 'button', class: 'ff-thumb' + (opts.current === url ? ' is-on' : ''), title: name, 'aria-pressed': opts.current === url ? 'true' : 'false' },
        thumbImg(url, name));
      const heart = h('span', { class: 'ff-heart' + (isSaved(which, url) ? ' is-on' : ''), role: 'button', tabindex: '0', 'aria-label': 'Save ' + name, title: 'Save' }, '♥');
      heart.addEventListener('click', e => { e.stopPropagation(); toggleSaved(which, url, name); heart.classList.toggle('is-on'); });
      b.append(heart);
      b.addEventListener('click', () => {
        pushRecent(which, url, name);
        opts.current = url;
        grid.querySelectorAll('.ff-thumb').forEach(t => { t.classList.toggle('is-on', t === b); t.setAttribute('aria-pressed', t === b ? 'true' : 'false'); });
        opts.onPick(url, name, cat);
      });
      grid.append(b);
    });
    const frag = h('div', null, grid);
    if (pages > 1) {
      const go = (d, fromKey) => {
        const to = st.pg + d;
        if (to < 0 || to >= pages) return false;
        st.pg = to; draw(d);
        if (fromKey) {                     /* keep keyboard focus on the pager after the page is redrawn */
          const btns = body.querySelectorAll('.ff-pg-btn'), want = btns[d > 0 ? 1 : 0];
          ((want && !want.disabled) ? want : btns[d > 0 ? 0 : 1] || want)?.focus({ preventScroll: true });
        }
        return true;
      };
      const arrow = (d, label, path) => h('button', { type: 'button', class: 'ff-pg-btn', 'aria-label': label, disabled: (d < 0 ? st.pg === 0 : st.pg >= pages - 1) ? '' : null, onclick: e => go(d, e.detail === 0),
        html: '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="' + path + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' });
      frag.append(h('nav', { class: 'ff-pager', 'aria-label': 'Pages' },
        arrow(-1, 'Previous page', 'M10 3L5 8L10 13'),
        h('span', { class: 'ff-pg-label' }, (start + 1) + '–' + Math.min(start + PAGE, items.length) + ' of ' + items.length.toLocaleString()),
        arrow(1, 'Next page', 'M6 3L11 8L6 13')));
      /* sideways swipe turns the page; vertical movement stays a normal scroll (touch-action: pan-y) */
      let x0 = 0, y0 = 0, pid = null;
      grid.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') { pid = e.pointerId; x0 = e.clientX; y0 = e.clientY; } });
      grid.addEventListener('pointercancel', () => { pid = null; });
      grid.addEventListener('pointerup', e => {
        if (e.pointerId !== pid) return;
        pid = null;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          /* only a swipe that turned the page eats the click that may follow it (the grid is replaced) */
          if (go(dx < 0 ? 1 : -1)) grid.addEventListener('click', ev => { ev.stopPropagation(); ev.preventDefault(); }, { capture: true, once: true });
        }
      });
    }
    if (st.turn) { grid.classList.add(st.turn > 0 ? 'is-from-next' : 'is-from-prev'); st.turn = 0; }
    if (!items.length) frag.append(h('p', { class: 'ff-note' }, 'Nothing here yet.'));
    return frag;
  }
  function draw(turn) {
    st.turn = typeof turn === 'number' ? turn : 0;
    body.textContent = '';
    const m = LIB[which];
    if (!m) {
      body.append(h('p', { class: 'ff-note' }, 'Loading the library…'));
      loadManifest(which).then(draw).catch(() => { body.textContent = ''; body.append(h('p', { class: 'ff-note is-warn' }, 'The pattern library did not load. Check your connection and reopen this tab.')); });
      return;
    }
    const q = st.q.toLowerCase();
    if (st.view === 'cat' && st.cat) {
      const cat = catById(which, st.cat);
      if (!cat) { st.view = 'themes'; return draw(); }
      body.append(crumb(st.theme || 'All themes', () => { st.view = st.theme ? 'theme' : 'themes'; st.pg = 0; draw(); }),
        h('h4', { class: 'ff-lib-title' }, cat.name, h('span', { class: 'ff-count' }, ' ' + cat.count)));
      const files = q ? cat.files.filter(f => f.name.toLowerCase().indexOf(q) >= 0) : cat.files;
      body.append(thumbGrid(files.map(f => ({ u: fileUrl(cat, f), n: f.name })), cat));
      return;
    }
    if (st.view === 'saved' || st.view === 'recent') {
      body.append(crumb('All themes', () => { st.view = 'themes'; draw(); }), h('h4', { class: 'ff-lib-title' }, st.view === 'saved' ? 'Saved' : 'Recently used'));
      body.append(thumbGrid(st.view === 'saved' ? savedList(which) : lsGet('flowforge:recent:' + which, []), null));
      return;
    }
    const themes = themesOf(m);
    if (q) {
      /* search: category names first, then file names across the whole library */
      const cats = m.categories.filter(c => (c.name + ' ' + (c.theme || '')).toLowerCase().indexOf(q) >= 0);
      if (cats.length) {
        body.append(h('h4', { class: 'ff-lib-title' }, 'Categories'));
        const list = h('div', { class: 'ff-chips' });
        cats.slice(0, 30).forEach(c => list.append(h('button', { type: 'button', class: 'ff-chip', onclick: () => { st.view = 'cat'; st.cat = c.id; st.theme = c.theme || ''; st.q = ''; search.value = ''; st.pg = 0; draw(); } }, c.name + ' (' + c.count + ')')));
        body.append(list);
      }
      const hits = [];
      for (const c of m.categories) { for (const f of c.files) { if (f.name.toLowerCase().indexOf(q) >= 0) { hits.push({ u: fileUrl(c, f), n: f.name }); if (hits.length >= 240) break; } } if (hits.length >= 240) break; }
      if (hits.length) { body.append(h('h4', { class: 'ff-lib-title' }, 'Patterns')); body.append(thumbGrid(hits, null)); }
      if (!cats.length && !hits.length) body.append(h('p', { class: 'ff-note' }, 'No matches for “' + st.q + '”. Try a theme below or a simpler word.'));
      return;
    }
    const top = h('div', { class: 'ff-chips' });
    top.append(h('button', { type: 'button', class: 'ff-chip is-accent', onclick: () => { st.view = 'saved'; st.pg = 0; draw(); } }, '♥ Saved'),
      h('button', { type: 'button', class: 'ff-chip', onclick: () => { st.view = 'recent'; st.pg = 0; draw(); } }, 'Recent'));
    body.append(top);
    if (st.view === 'theme' && st.theme) {
      const t = themes.find(x => x.name === st.theme);
      if (t) {
        body.append(crumb('All themes', () => { st.view = 'themes'; draw(); }), h('h4', { class: 'ff-lib-title' }, t.name));
        const grid = h('div', { class: 'ff-cats' });
        t.cats.forEach(c => grid.append(catCard(c)));
        body.append(grid);
        return;
      }
    }
    const grid = h('div', { class: 'ff-cats' });
    themes.forEach(t => {
      const first = t.cats[0];
      const b = h('button', { type: 'button', class: 'ff-cat', onclick: () => { st.view = 'theme'; st.theme = t.name; draw(); } },
        thumbImg(first && first.files[0] ? fileUrl(first, first.files[0]) : '', ''),
        h('span', null, t.name), h('small', null, t.cats.reduce((n, c) => n + c.count, 0).toLocaleString()));
      grid.append(b);
    });
    body.append(grid);
  }
  function catCard(c) {
    return h('button', { type: 'button', class: 'ff-cat', onclick: () => { st.view = 'cat'; st.cat = c.id; st.pg = 0; draw(); } },
      thumbImg(c.files[0] ? fileUrl(c, c.files[0]) : '', ''), h('span', null, c.name), h('small', null, c.count.toLocaleString()));
  }
  draw();
  return box;
}
/* a random pick (for Surprise me and shuffle buttons), optionally from one theme */
function randomFile(which, r, theme) {
  const m = LIB[which];
  if (!m) return null;
  const cats = m.categories.filter(c => c.files.length && (!theme || c.theme === theme));
  if (!cats.length) return null;
  const cat = r.pick(cats), f = r.pick(cat.files);
  return { url: fileUrl(cat, f), name: f.name, cat };
}

/* ── 10-ui-core.js ── */
/* ── UI CORE: elements, controls, feedback ── */
function h(tag, props) {
  const el = document.createElement(tag);
  if (props) for (const k in props) {
    const v = props[k];
    if (v == null || v === false) continue;
    if (k === 'class') el.className = v;
    else if (k.slice(0, 2) === 'on' && typeof v === 'function') el.addEventListener(k.slice(2), v);
    else if (k === 'value') el.value = v;
    else if (k === 'checked') el.checked = !!v;
    else if (k === 'html') el.innerHTML = v;
    else el.setAttribute(k, v === true ? '' : v);
  }
  for (let i = 2; i < arguments.length; i++) addKids(el, arguments[i]);
  return el;
}
function addKids(el, c) {
  if (c == null || c === false) return;
  if (Array.isArray(c)) { c.forEach(x => addKids(el, x)); return; }
  el.append(c.nodeType ? c : document.createTextNode(String(c)));
}
const $ = sel => ROOT.querySelector(sel);

/* every edit: draw now, record an undo step once the edit settles */
function changed(structural) { requestRender(); commitSoon(); if (structural) refreshPanel(); }

function section(title, ...kids) {
  return h('section', { class: 'ff-sec' },
    title ? h('h3', { class: 'ff-sec-title' }, title) : null, kids);
}

/* ── INFO TIPS: ⓘ button that toggles a help bubble ── */
function tip(text, videoUrl) {
  const bubble = h('div', { class: 'ff-tip-body', hidden: true },
    h('p', null, text),
    videoUrl ? h('a', { href: videoUrl, target: '_blank', rel: 'noopener', class: 'ff-tip-video' }, '📺 Watch how') : null,
    h('button', { type: 'button', class: 'ff-tip-close', 'aria-label': 'Close tip', onclick: () => { bubble.hidden = true; } }, '✕'));
  const toggle = h('button', { type: 'button', class: 'ff-tip-btn', 'aria-label': 'Info', title: 'Info',
    onclick: () => { bubble.hidden = !bubble.hidden; } }, 'ⓘ');
  return h('span', { class: 'ff-tip' }, toggle, bubble);
}
/* section with an info tip — use titled() for the heading */
function titled(title, tipText, videoUrl) {
  return h('h3', { class: 'ff-sec-title' }, title, tipText ? tip(tipText, videoUrl) : null);
}
function note(text, warn) { return h('p', { class: 'ff-note' + (warn ? ' is-warn' : '') }, text); }
function row(...kids) { return h('div', { class: 'ff-row' }, kids); }
function btn(label, fn, cls, extra) { return h('button', Object.assign({ type: 'button', class: 'ff-btn' + (cls ? ' ' + cls : ''), onclick: fn }, extra || {}), label); }

/* labelled range slider. onInput gets the number; one undo step per drag */
function slider(label, value, min, max, step, onInput, fmtv) {
  const out = h('output', { class: 'ff-val' }, fmtv ? fmtv(value) : String(value));
  const inp = h('input', { type: 'range', min, max, step, value, 'aria-label': label });
  inp.addEventListener('input', () => { const v = parseFloat(inp.value); out.textContent = fmtv ? fmtv(v) : String(v); onInput(v); requestRender(); });
  inp.addEventListener('change', commit);
  return h('label', { class: 'ff-slider' }, h('span', { class: 'ff-lbl' }, label), inp, out);
}
/* a row of choices; current = id */
function seg(options, current, onPick, label) {
  const g = h('div', { class: 'ff-seg', role: 'group', 'aria-label': label || '' });
  options.forEach(o => {
    const on = o.id === current;
    g.append(h('button', { type: 'button', class: 'ff-seg-btn' + (on ? ' is-on' : ''), 'aria-pressed': on ? 'true' : 'false', title: o.title || null,
      disabled: o.disabled || null, onclick: () => onPick(o.id) }, o.label));
  });
  return g;
}
function check(label, on, fn) {
  const inp = h('input', { type: 'checkbox', checked: on });
  inp.addEventListener('change', () => fn(inp.checked));
  return h('label', { class: 'ff-check' }, inp, h('span', null, label));
}

/* ── PAINT PICKER: solid swatches + custom, or a gradient (presets, stops, angle) ── */
function paintPicker(paint, onChange, opts) {
  opts = opts || {};
  const box = h('div', { class: 'ff-paint' });
  let p = paint;
  function set(np) { p = np; onChange(np); requestRender(); commitSoon(); draw(); }
  function draw() {
    box.textContent = '';
    const kind = isHex(p) ? 'solid' : p.t;
    if (opts.gradients !== false) {
      box.append(seg([{ id: 'solid', label: 'Solid' }, { id: 'linear', label: 'Linear' }, { id: 'radial', label: 'Radial' }, { id: 'sweep', label: 'Sweep' }], kind, id => {
        if (id === kind) return;
        if (id === 'solid') set(paintColors(p)[0]);
        else if (isHex(p)) set({ t: id, a: id === 'linear' ? 90 : 0, s: [[0, p], [1, mixHex(p, '#ffffff', 0.55)]] });
        else set({ t: id, a: p.a, s: p.s });
      }, 'Paint type'));
    }
    if (isHex(p)) {
      const sw = h('div', { class: 'ff-swatches' });
      (opts.swatches || SWATCHES).forEach(c => sw.append(h('button', { type: 'button', class: 'ff-sw' + (c === p ? ' is-on' : ''), style: 'background:' + c, title: c, 'aria-label': 'Colour ' + c, onclick: () => set(c) })));
      const custom = h('input', { type: 'color', value: p, 'aria-label': 'Custom colour', class: 'ff-color' });
      custom.addEventListener('input', () => { p = custom.value; onChange(p); requestRender(); hex.value = p; });
      custom.addEventListener('change', () => { commit(); draw(); });
      const hex = h('input', { type: 'text', class: 'ff-input ff-hex', value: p, maxlength: '7', 'aria-label': 'Hex colour', spellcheck: 'false' });
      hex.addEventListener('change', () => { const v = hex.value.trim().replace(/^([^#])/, '#$1'); if (isHex(v)) set(v.toLowerCase()); else hex.value = p; });
      box.append(sw, row(custom, hex));
      return;
    }
    /* gradient */
    box.append(h('div', { class: 'ff-gbar', style: 'background:' + paintCss(Object.assign({}, p, { t: 'linear', a: 0 })) }));
    const pre = h('div', { class: 'ff-gpresets' });
    Object.keys(GRADIENTS).forEach(name => {
      const gp = gradPaint(name, p.t, p.a);
      pre.append(h('button', { type: 'button', class: 'ff-gp', title: name, 'aria-label': name + ' gradient', style: 'background:' + paintCss(Object.assign({}, gp, { t: 'linear', a: 0 })), onclick: () => set(gp) }));
    });
    box.append(pre);
    p.s.forEach((s, i) => {
      const c = h('input', { type: 'color', value: s[1], class: 'ff-color', 'aria-label': 'Stop ' + (i + 1) + ' colour' });
      c.addEventListener('input', () => { p.s[i][1] = c.value; onChange(p); requestRender(); });
      c.addEventListener('change', () => { commit(); draw(); });
      const pos = h('input', { type: 'range', min: 0, max: 1, step: 0.01, value: s[0], 'aria-label': 'Stop ' + (i + 1) + ' position' });
      pos.addEventListener('input', () => { p.s[i][0] = parseFloat(pos.value); onChange(cleanPaint(p)); requestRender(); });
      pos.addEventListener('change', () => { p = cleanPaint(p); onChange(p); commit(); draw(); });
      const rm = p.s.length > 2 ? h('button', { type: 'button', class: 'ff-x', 'aria-label': 'Remove stop', onclick: () => { p.s.splice(i, 1); set(cleanPaint(p)); } }, '×') : null;
      box.append(h('div', { class: 'ff-stop' }, c, pos, rm));
    });
    if (p.s.length < 6) box.append(btn('+ Add colour', () => { const s = p.s; const last = s[s.length - 1]; s.push([1, mixHex(last[1], '#ffffff', 0.4)]); s.forEach((x, i) => { x[0] = round(i / (s.length - 1), 3); }); set(cleanPaint(p)); }, 'is-quiet'));
    if (p.t !== 'radial') box.append(slider(p.t === 'sweep' ? 'Start angle' : 'Direction', p.a, 0, 359, 1, v => { p.a = v; onChange(p); }, v => Math.round(v) + '°'));
  }
  draw();
  return box;
}
/* ── FEEDBACK ── */
let toastTimer = 0;
function toast(msg, actionLabel, action) {
  const t = $('[data-ff-toast]');
  if (!t) return;
  t.textContent = '';
  t.append(h('span', null, msg));
  if (actionLabel) t.append(h('button', { type: 'button', class: 'ff-toast-act', onclick: () => { action(); t.hidden = true; } }, actionLabel));
  t.hidden = false; t.classList.remove('is-out');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => { t.classList.add('is-out'); setTimeout(() => { t.hidden = true; }, 180); }, actionLabel ? 6000 : 3200);
}
function showBusy(msg) {
  const b = $('[data-ff-handoff]');
  b.hidden = false; b.querySelector('span').textContent = msg;
  return m => { b.querySelector('span').textContent = m; };
}
function hideBusy() { $('[data-ff-handoff]').hidden = true; }
function showGate(msg) { const g = $('[data-ff-gate]'); g.textContent = msg; g.hidden = !msg; }

/* ── TABS + SIDES ── */
const TABS = [
  { id: 'looks', label: 'Looks', icon: 'M12 3l1.8 4.6L18.5 9l-4.7 1.4L12 15l-1.8-4.6L5.5 9l4.7-1.4z M18.5 15l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9z' },
  { id: 'background', label: 'Background', icon: 'M4 4h16v16H4z M4 12h16 M12 4v16' },
  { id: 'mandala', label: 'Mandala', icon: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18 M12 7.5a4.5 4.5 0 1 0 0 9a4.5 4.5 0 1 0 0-9 M12 3v4.5 M12 16.5V21 M3 12h4.5 M16.5 12H21' },
  { id: 'points', label: 'Points', icon: 'M12 2l2.2 5.4 5.8.6-4.4 3.9 1.3 5.7L12 14.6 7.1 17.6l1.3-5.7L4 8l5.8-.6z' },
  { id: 'art', label: 'Art', icon: 'M4 5h16v14H4z M4 15l4.5-4.5 4 4 2.5-2.5 5 5 M15.5 9.5a1.5 1.5 0 1 0 0 .01' },
  { id: 'text', label: 'Text', icon: 'M5 6V4h14v2 M12 4v16 M9 20h6' }
];
function icon(d) { return h('span', { class: 'ff-tab-ico', 'aria-hidden': 'true', html: '<svg viewBox="0 0 24 24" width="20" height="20"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' }); }
function buildTabs() {
  const nav = $('[data-ff-tabs]');
  nav.textContent = '';
  TABS.forEach(t => {
    nav.append(h('button', { type: 'button', role: 'tab', class: 'ff-tab', 'data-tab': t.id, 'aria-selected': ui.tab === t.id ? 'true' : 'false', 'aria-controls': 'ff-pane',
      onclick: () => setTab(t.id) }, icon(t.icon), h('span', null, t.label)));
  });
}
function setTab(id) {
  ui.tab = id;
  ROOT.setAttribute('data-ff-tab', id);
  ROOT.querySelectorAll('.ff-tab').forEach(b => b.setAttribute('aria-selected', b.getAttribute('data-tab') === id ? 'true' : 'false'));
  if (id === 'background' && ui.sel.kind !== 'wedge') ui.sel = { kind: 'base' };
  if (id === 'points') ui.sel = { kind: 'point', ks: linkedPoints(ui.pointSel) };
  if (id === 'mandala' || id === 'art' || id === 'text') {
    const d = curDesign(), want = id === 'art' ? 'art' : id;
    const cur = selectedLayerIndex();
    if (cur < 0 || d.layers[cur].type !== want) {
      const j = d.layers.map((L, i) => L.type === want ? i : -1).filter(i => i >= 0).pop();
      selectLayer(j == null ? -1 : j, true);
    }
  }
  refreshPanel(true);
  requestRender();
}
function setSide(i) {
  if (i === 1 && state.numSides < 2) return;
  state.activeSide = i;
  ui.sel = { kind: 'base' };
  flipAnimation();
  refreshPanel(true);
  requestRender();
}
function addSide() {
  state.numSides = 2;
  toast('Side 2 added. Start it from scratch, or copy side 1.', 'Copy side 1', () => { state.designs[1] = deepClone(state.designs[0]); commit(); requestRender(); refreshPanel(); });
  setSide(1);
  commit();
}
function removeSide() {
  const keep = deepClone(state.designs[1]);
  state.numSides = 1; setSide(0); commit();
  toast('Side 2 removed.', 'Undo', () => { state.numSides = 2; state.designs[1] = keep; commit(); setSide(1); });
}
function syncChrome() {
  ROOT.querySelectorAll('.ff-side').forEach(b => {
    const i = +b.getAttribute('data-side');
    b.hidden = i === 1 && state.numSides < 2;
    b.classList.toggle('is-on', i === state.activeSide);
    b.setAttribute('aria-pressed', i === state.activeSide ? 'true' : 'false');
  });
  const add = $('[data-act="add-side"]');
  if (add) add.hidden = state.numSides === 2;
  const u = $('[data-act="undo"]'), r = $('[data-act="redo"]');
  if (u) u.disabled = !history.past.length && history.last === snapshot();
  if (r) r.disabled = !history.future.length;
  ROOT.querySelectorAll('[data-view]').forEach(b => {
    const k = b.getAttribute('data-view');
    const on = k === 'flow' ? !!ui.spinning : !!ui.view[k];
    b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  const g = $('[data-ff-gate]');
  if (g && !g.hidden) {
    const still = []; for (let i = 0; i < state.numSides; i++) { const p = sideProblem(i); if (p) still.push(p); }
    showGate(still.join(' '));
  }
}
let renderQueued = false;
function requestRender() {
  if (renderQueued) return;
  renderQueued = true;
  requestAnimationFrame(() => { renderQueued = false; renderStage(); syncChrome(); });
}
let paneScroll = 0;
function refreshPanel(fromTop) {
  const pane = $('[data-ff-pane]');
  if (!pane) return;
  const y = window.scrollY;
  pane.textContent = '';
  const build = PANELS[ui.tab] || PANELS.looks;
  pane.append(build());
  if (!fromTop) window.scrollTo(0, y);
  paneScroll = 0;
}

/* ── 11-panels.js ── */
/* ── PANELS (one per tab) ── */
const PANELS = {};

/* Help text shown in ⓘ info popovers. videoUrl is optional — add timestamps
   to your walkthrough videos once they are published. */
const TIPS = {
  looks:       'Pick a starting look to set the whole star at once — background, mandala, points and colours. You can change every detail afterwards.',
  surprise:    'Generates a random design with colours that work together. Press it again for a new one, or Undo to go back. Lock parts you want to keep.',
  bgType:      'Pattern fills the star with a seamless image. Colour uses a solid or gradient. Kaleidoscope mirrors a pattern into a symmetrical design.',
  bgPattern:   'Drag the slider to make the pattern bigger or smaller. "Shuffle" picks another pattern from the same category.',
  bgLogo:      'Every FlowStar has the Brain Plague Designs logo in the centre. You can shrink it or make it more transparent.',
  blank:       'Starts an empty star: no background, mandala, points, art or text. You begin with the background.',
  wedges:      'Split the star into 8 slices, each with its own pattern. Great for a patchwork look.',
  mandala:     'A mandala is built from rings of shapes — rays, petals, spirals and more. Each ring has its own motif, colour and size.',
  mandalaGen:  'Generate creates random rings that look good together. Or start with 3 basic rings and customise from there.',
  ringShape:   'Pick the motif for this ring. Each shape tiles around the circle.',
  ringSize:    'Inner/outer edge controls where the ring sits. "How many" sets the repeat count.',
  ringColour:  'One paint colours every shape the same. Alternate paints every other shape: pick Shapes A or Shapes B, and the shapes you are painting are outlined on the star. Spectrum spreads a gradient around the ring.',
  ringExtras:  'Add a coloured band behind the shapes, or outline each shape for a stained-glass effect.',
  points:      'The 8 points of the star. Edit them all together, in alternating pairs, or one by one. Each point can have its own fill and symbol.',
  pointFill:   '"Show background" lets the star pattern show through. Colour fills the point solid. Pattern uses a seamless image.',
  pointSymbol: 'Add a shape to each point — a dot, heart, star, moon and more. Resize and recolour it.',
  art:         'Art layers sit on top of your design. Line art can be recoloured; full-colour pieces keep their original look. Drag art on the star to move it.',
  artColour:   'One colour tints the art. Gradient fills it with a colour ramp. Original uses the art\'s own colours.',
  artPlace:    'Single places one copy. Repeat tiles the art across the star. Drag on the star to reposition.',
  text:        'Add a name, word or date. Curve it around the star or set it straight. Everything prints exactly as you type it.',
  textFont:    'Pick a font — each one prints at high resolution. Scroll for more options.',
  textShape:   'Curved wraps the text along a circle inside the star. Straight keeps it flat — drag to position.',
  textColour:  'Pick a colour or gradient for the text. Add an outline to make it pop against busy backgrounds.',
  layers:      'Layers stack from bottom to top. Drag to reorder, hide to preview without, or delete. The star background is always behind all layers.',
  bothSides:   'Copy your finished design to the other side, or remove side 2 to make a single-sided star.',
};

/* selection helpers */
function selectedLayerIndex() { return ui.sel.kind === 'layer' ? ui.sel.i : -1; }
function selectLayer(j, quiet) {
  ui.sel = j >= 0 ? { kind: 'layer', i: j } : { kind: 'base' };
  if (!quiet) { refreshPanel(); requestRender(); }
}
function linkedPoints(k) {
  const link = curDesign().points.link;
  return link === 'all' ? [0, 1, 2, 3, 4, 5, 6, 7] : link === 'alt' ? [0, 1, 2, 3, 4, 5, 6, 7].filter(i => i % 2 === k % 2) : [k];
}
function addLayer(L) {
  const d = curDesign();
  if (d.layers.length >= MAX_LAYERS) { toast('A side holds up to ' + MAX_LAYERS + ' layers. Remove one first.'); return -1; }
  d.layers.push(L);
  ui.sel = { kind: 'layer', i: d.layers.length - 1 };
  commit();
  return d.layers.length - 1;
}
function removeLayer(i) {
  const d = curDesign(), gone = d.layers.splice(i, 1)[0];
  selectLayer(-1, true); commit(); refreshPanel(); requestRender();
  toast('Layer removed.', 'Undo', () => { d.layers.splice(i, 0, gone); commit(); selectLayer(i); });
}
function moveLayer(i, dir) {
  const d = curDesign(), j = i + dir;
  if (j < 0 || j >= d.layers.length) return;
  const t = d.layers[i]; d.layers[i] = d.layers[j]; d.layers[j] = t;
  ui.sel = { kind: 'layer', i: j }; changed(true);
}
const TYPE_LABEL = { art: 'Art', mandala: 'Mandala', text: 'Text' };
const TYPE_TAB = { art: 'art', mandala: 'mandala', text: 'text' };
function layerName(L) { return L.type === 'text' ? '“' + (L.text || 'Text') + '”' : L.type === 'mandala' ? 'Mandala, ' + L.rings.length + (L.rings.length === 1 ? ' ring' : ' rings') : (L.name || 'Art'); }
/* the stack of this side's layers, top first */
function layersList() {
  const d = curDesign();
  if (!d.layers.length) return null;
  const list = h('ol', { class: 'ff-layers', 'aria-label': 'Layers, top first' });
  for (let i = d.layers.length - 1; i >= 0; i--) {
    const L = d.layers[i], on = selectedLayerIndex() === i;
    list.append(h('li', { class: 'ff-layer' + (on ? ' is-on' : '') + (L.hidden ? ' is-hidden' : '') },
      h('button', { type: 'button', class: 'ff-layer-main', 'aria-pressed': on ? 'true' : 'false', onclick: () => { ui.sel = { kind: 'layer', i }; if (ui.tab !== TYPE_TAB[L.type]) setTab(TYPE_TAB[L.type]); else { refreshPanel(); requestRender(); } } },
        h('span', { class: 'ff-layer-type' }, TYPE_LABEL[L.type]), h('span', { class: 'ff-layer-name' }, layerName(L))),
      h('button', { type: 'button', class: 'ff-mini', 'aria-label': L.hidden ? 'Show layer' : 'Hide layer', title: L.hidden ? 'Show' : 'Hide', onclick: () => { L.hidden = !L.hidden; changed(true); } }, L.hidden ? '◌' : '◉'),
      h('button', { type: 'button', class: 'ff-mini', 'aria-label': 'Move up', title: 'Move up', disabled: i === d.layers.length - 1 || null, onclick: () => moveLayer(i, 1) }, '↑'),
      h('button', { type: 'button', class: 'ff-mini', 'aria-label': 'Move down', title: 'Move down', disabled: i === 0 || null, onclick: () => moveLayer(i, -1) }, '↓')));
  }
  return h('section', { class: 'ff-sec' }, titled('Layers on side ' + (state.activeSide + 1), TIPS.layers), list);
}

/* icons drawn with the real motif code, so what you pick is what you get */
const iconCache = {};
function motifIcon(m) {
  if (iconCache[m]) return iconCache[m];
  const g = ringParts(Object.assign(makeRing(m), { n: MOTIFS[m].cont ? 6 : 8, r0: 0.36, r1: 0.96, size: m === 'lace' ? 0.9 : 0.82, weight: 14, twist: 90 }));
  const body = g.parts.map(d => '<path d="' + d + '"/>').join('');
  return (iconCache[m] = '<svg viewBox="16 16 368 368" aria-hidden="true"><g ' + (g.stroke ? 'fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"' : 'fill="currentColor" fill-rule="evenodd"') + '>' + body + '</g></svg>');
}
function pointIcon(m) {
  const key = 'p:' + m;
  if (iconCache[key]) return iconCache[key];
  const sh = { dot: SHAPES.dot, bubble: SHAPES.bubble, star: SHAPES.star, heart: SHAPES.heart, moon: moonShape(0.3), leaf: SHAPES.leaf, flame: SHAPES.flame, drop: SHAPES.drop,
    diamond: SHAPES.diamond, eye: SHAPES.eye, curl: SPIRAL_L, scroll: SCROLL_L }[m];
  const d = place(sh, 0, 0, m === 'scroll' ? 90 : 0, 0.8, 0.8);
  return (iconCache[key] = '<svg viewBox="-1 -1 2 2" aria-hidden="true"><path d="' + d + '" ' + (pointMotifIsStroke(m) ? 'fill="none" stroke="currentColor" stroke-width=".14" stroke-linecap="round"' : 'fill="currentColor" fill-rule="evenodd"') + '/></svg>');
}
function iconGrid(ids, current, iconFn, labelFn, onPick, label) {
  const g = h('div', { class: 'ff-icons', role: 'group', 'aria-label': label });
  ids.forEach(id => {
    const on = id === current;
    g.append(h('button', { type: 'button', class: 'ff-icon-btn' + (on ? ' is-on' : ''), 'aria-pressed': on ? 'true' : 'false', title: labelFn(id), onclick: () => onPick(id) },
      h('span', { class: 'ff-icon-img', html: iconFn(id) }), h('span', { class: 'ff-icon-lbl' }, labelFn(id))));
  });
  return g;
}

/* ── LOOKS ── */
PANELS.looks = function () {
  const wrap = h('div');
  wrap.append(section(null, h('p', { class: 'ff-lead' }, 'Start from a look, then make it yours. Every part stays editable.')));
  const grid = h('div', { class: 'ff-looks' });
  grid.append(h('button', { type: 'button', class: 'ff-look ff-look-blank', 'aria-label': 'Start from a blank canvas', title: TIPS.blank, onclick: () => blankCanvas() },
    h('span', { class: 'ff-look-img', html: renderSide(makeDesign(), { idp: 'lkb', mode: 'thumb' }) }), h('span', { class: 'ff-look-name' }, 'Blank canvas')));
  LOOKS.forEach((look, i) => {
    const d = lookDesign(look);
    const b = h('button', { type: 'button', class: 'ff-look', 'aria-label': 'Use the ' + look.name + ' look', onclick: () => applyLook(look) },
      h('span', { class: 'ff-look-img', html: renderSide(d, { idp: 'lk' + i, mode: 'thumb' }) }), h('span', { class: 'ff-look-name' }, look.name));
    grid.append(b);
  });
  wrap.append(h('section', { class: 'ff-sec' }, titled('Starting looks', TIPS.looks), grid));
  const vibe = ui.vibe || 'any';
  const vibes = [{ id: 'any', label: 'Any vibe' }].concat(Object.keys(VIBES).map(k => ({ id: k, label: VIBES[k].label })));
  const locks = ['background', 'mandala', 'points', 'art'].map(k => check({ background: 'Keep my background', mandala: 'Keep my mandala', points: 'Keep my points', art: 'Keep my art & text' }[k],
    !!ui.locks[k], v => { ui.locks[k] = v; }));
  wrap.append(h('section', { class: 'ff-sec' }, titled('Surprise me', TIPS.surprise),
    note('A fresh, one-of-a-kind design from matching colours. Not quite right? Press it again, or Undo.'),
    h('div', { class: 'ff-chips' }, vibes.map(v => h('button', { type: 'button', class: 'ff-chip' + (vibe === v.id ? ' is-on' : ''), 'aria-pressed': vibe === v.id ? 'true' : 'false', onclick: () => { ui.vibe = v.id; refreshPanel(); } }, v.label))),
    h('div', { class: 'ff-locks' }, locks),
    btn('Surprise me', () => surpriseMe(), 'is-primary ff-big')));
  if (state.numSides === 2) {
    wrap.append(h('section', { class: 'ff-sec' }, titled('Both sides', TIPS.bothSides), btn('Copy this side to the other side', () => {
      const other = state.activeSide ? 0 : 1, keep = deepClone(state.designs[other]);
      state.designs[other] = deepClone(curDesign()); commit(); requestRender();
      toast('Side ' + (other + 1) + ' now matches.', 'Undo', () => { state.designs[other] = keep; commit(); requestRender(); });
    }), btn('Remove side 2', removeSide, 'is-quiet')));
  }
  return wrap;
};

/* ── BACKGROUND ── */
PANELS.background = function () {
  const d = curDesign(), b = d.base, wrap = h('div');
  wrap.append(h('section', { class: 'ff-sec' }, titled('Fill the star', TIPS.bgType), seg([{ id: 'pattern', label: 'Pattern' }, { id: 'paint', label: 'Colour' }, { id: 'kaleido', label: 'Kaleidoscope' }], b.kind, id => {
    b.kind = id; if (id !== 'paint' && !b.url) loadManifest('bg').catch(() => {}); changed(true);
  }, 'Background type')));
  if (b.kind === 'paint') {
    wrap.append(section('Colour or gradient', paintPicker(b.paint, p => { b.paint = p; })));
  } else {
    if (b.url) {
      const tools = [slider(b.kind === 'kaleido' ? 'Zoom' : 'Pattern size', b.scale, 10, 400, 1, v => { b.scale = v; }, v => Math.round(v) + '%')];
      if (b.kind === 'kaleido') {
        tools.unshift(h('div', { class: 'ff-field' }, h('span', { class: 'ff-lbl' }, 'Mirrors'),
          seg([4, 6, 8, 12, 16, 24].map(n => ({ id: n, label: String(n) })), b.folds, n => { b.folds = n; changed(true); }, 'Mirror count')));
        tools.push(slider('Turn', b.krot, 0, 359, 1, v => { b.krot = v; }, v => Math.round(v) + '°'),
          slider('Slide across', b.kx, -200, 200, 1, v => { b.kx = v; }), slider('Slide down', b.ky, -200, 200, 1, v => { b.ky = v; }));
      }
      tools.push(row(btn('Shuffle within ' + (catById('bg', ui.lib.bg && ui.lib.bg.cat) ? 'this category' : 'the library'), () => shuffleBase(), 'is-quiet')));
      wrap.append(h('section', { class: 'ff-sec' }, titled(b.name ? 'Pattern: ' + b.name : 'Pattern', TIPS.bgPattern), ...tools));
    }
    wrap.append(section(b.url ? 'Choose another pattern' : 'Choose a pattern', libraryBrowser({ which: 'bg', current: b.url, onPick: (url, name) => {
      b.url = url; b.name = name; if (b.kind === 'paint') b.kind = 'pattern';
      requestRender(); commit(); refreshPanel();
    } })));
  }
  wrap.append(wedgesSection(d));
  return wrap;
};
function shuffleBase() {
  const b = curDesign().base, r = rng(Date.now() & 0xffffffff);
  const st = ui.lib.bg, cat = st && st.cat ? catById('bg', st.cat) : null;
  const pick = () => { const c = cat || r.pick(LIB.bg.categories.filter(x => x.files.length)); const f = r.pick(c.files); return { url: fileUrl(c, f), name: f.name }; };
  loadManifest('bg').then(() => { const p = pick(); b.url = p.url; b.name = p.name; changed(true); }).catch(() => toast('The pattern library did not load.'));
}
function wedgesSection(d) {
  const wrap = h('details', { class: 'ff-details', open: ui.sel.kind === 'wedge' || null });
  wrap.append(h('summary', null, 'Wedges: a different pattern in each of the 8 slices'));
  const grid = h('div', { class: 'ff-wedges' });
  d.wedges.forEach((w, i) => {
    const on = ui.sel.kind === 'wedge' && ui.sel.i === i;
    grid.append(h('button', { type: 'button', class: 'ff-wedge' + (w.enabled ? ' is-filled' : '') + (on ? ' is-on' : ''), 'aria-pressed': on ? 'true' : 'false',
      onclick: () => { ui.sel = on ? { kind: 'base' } : { kind: 'wedge', i }; refreshPanel(); requestRender(); } },
      w.enabled && w.bgUrl ? h('img', { src: w.bgUrl, alt: '' }) : null, h('span', null, WEDGE_LABELS[i])));
  });
  wrap.append(grid);
  if (ui.sel.kind === 'wedge') {
    const w = d.wedges[ui.sel.i];
    if (w.enabled && w.bgUrl) {
      wrap.append(slider('Pattern size', w.bgScale, 10, 400, 1, v => { w.bgScale = v; }, v => Math.round(v) + '%'),
        row(btn('Turn ⟲', () => { w.rot = snap45(w.rot - 45); changed(); }, 'is-quiet'), btn('Turn ⟳', () => { w.rot = snap45(w.rot + 45); changed(); }, 'is-quiet'),
          btn('Clear this wedge', () => { w.enabled = false; w.bgUrl = ''; changed(true); }, 'is-quiet')));
    }
    wrap.append(libraryBrowser({ which: 'bg', current: w.bgUrl, onPick: (url, name) => { w.enabled = true; w.bgUrl = url; w.bgName = name; requestRender(); commit(); refreshPanel(); } }));
  }
  wrap.append(row(btn('Fill all 8 from one category', () => {
    loadManifest('bg').then(() => {
      const r = rng(Date.now() & 0xffffffff), st = ui.lib.bg, cat = (st && st.cat && catById('bg', st.cat)) || r.pick(LIB.bg.categories.filter(c => c.files.length > 8));
      const scale = r.pick([40, 60, 80, 100]);
      d.wedges.forEach((w, i) => { const f = r.pick(cat.files); d.wedges[i] = { enabled: true, bgUrl: fileUrl(cat, f), bgName: f.name, bgScale: scale, rot: i * 45 }; });
      changed(true);
    });
  }, 'is-quiet'), d.wedges.some(w => w.enabled) ? btn('Clear all wedges', () => { d.wedges = makeWedges(); ui.sel = { kind: 'base' }; changed(true); }, 'is-quiet') : null));
  return wrap;
}

/* ── MANDALA ── */
PANELS.mandala = function () {
  const d = curDesign(), wrap = h('div');
  let i = selectedLayerIndex();
  let M = i >= 0 && d.layers[i].type === 'mandala' ? d.layers[i] : null;
  if (!M) {
    wrap.append(h('section', { class: 'ff-sec' }, titled('Mandala', TIPS.mandala),
      h('p', { class: 'ff-lead' }, 'Build a mandala from rings of shapes: rays, petals, moons, spirals and more. It is drawn as vector art, so it prints razor sharp.'),
      row(btn('Generate a mandala', () => { const r = rng(Date.now() & 0xffffffff); const L = makeMandala(); L.rings = generateRings(r, pickPalette(r)); if (addLayer(L) >= 0) changed(true); }, 'is-primary'),
        btn('Start with 3 rings', () => { const L = makeMandala(); L.rings = starterRings(); if (addLayer(L) >= 0) changed(true); }))));
    const ll = layersList(); if (ll) wrap.append(ll);
    return wrap;
  }
  const ll = layersList(); if (ll) wrap.append(ll);
  M.sel = clampNum(M.sel, 0, Math.max(0, M.rings.length - 1), 0);
  const list = h('ol', { class: 'ff-rings', 'aria-label': 'Rings, outside first' });
  M.rings.map((g, j) => ({ g, j })).sort((a, b) => b.g.r1 - a.g.r1).forEach(({ g, j }) => {
    const on = M.sel === j;
    list.append(h('li', { class: 'ff-ring' + (on ? ' is-on' : '') + (g.hidden ? ' is-hidden' : '') },
      h('button', { type: 'button', class: 'ff-ring-main', 'aria-pressed': on ? 'true' : 'false', onclick: () => { M.sel = j; refreshPanel(); requestRender(); } },
        h('span', { class: 'ff-ring-icon', html: motifIcon(g.motif), style: 'color:' + paintColors(g.fill)[0] }), h('span', null, MOTIFS[g.motif].label)),
      h('button', { type: 'button', class: 'ff-mini', 'aria-label': g.hidden ? 'Show ring' : 'Hide ring', onclick: () => { g.hidden = !g.hidden; changed(true); } }, g.hidden ? '◌' : '◉'),
      h('button', { type: 'button', class: 'ff-mini', 'aria-label': 'Duplicate ring', title: 'Duplicate', onclick: () => {
        if (M.rings.length >= MAX_RINGS) return toast('Up to ' + MAX_RINGS + ' rings per mandala.');
        const c = deepClone(g); M.rings.push(c); M.sel = M.rings.length - 1; changed(true); } }, '⧉'),
      h('button', { type: 'button', class: 'ff-mini', 'aria-label': 'Delete ring', title: 'Delete', onclick: () => {
        const gone = M.rings.splice(j, 1)[0]; M.sel = 0; changed(true);
        toast('Ring removed.', 'Undo', () => { M.rings.splice(j, 0, gone); M.sel = j; changed(true); }); } }, '×')));
  });
  wrap.append(section('Rings', list, row(btn('+ Add ring', () => {
    if (M.rings.length >= MAX_RINGS) return toast('Up to ' + MAX_RINGS + ' rings per mandala.');
    const g = makeRing('dots'), top = M.rings.reduce((m, x) => Math.max(m, x.r1), 0.1);
    g.r0 = Math.min(0.9, top + 0.02); g.r1 = Math.min(1, g.r0 + 0.12); g.fill = '#fbf6ec';
    M.rings.push(g); M.sel = M.rings.length - 1; changed(true);
  }), btn('Generate new rings', () => { const r = rng(Date.now() & 0xffffffff); M.rings = generateRings(r, pickPalette(r)); M.sel = 0; changed(true); }, 'is-quiet'))));
  const g = M.rings[M.sel];
  if (g) wrap.append(ringEditor(M, g));
  wrap.append(section('Whole mandala',
    slider('Turn', M.rot, 0, 359, 1, v => { M.rot = v; }, v => Math.round(v) + '°'),
    slider('Opacity', Math.round(M.opacity * 100), 5, 100, 1, v => { M.opacity = v / 100; }, v => v + '%'),
    row(btn('Remove mandala', () => removeLayer(selectedLayerIndex()), 'is-quiet'))));
  return wrap;
};
function ringEditor(M, g) {
  const m = MOTIFS[g.motif];
  const out = h('div');
  out.append(h('section', { class: 'ff-sec' }, titled('Shape', TIPS.ringShape), iconGrid(MOTIF_IDS, g.motif, motifIcon, id => MOTIFS[id].label, id => { g.motif = id; changed(true); }, 'Ring shape')));
  const size = [
    slider(m.cont ? (g.motif === 'band' ? 'Count (no effect)' : 'Repeats') : 'How many', g.n, 1, 96, 1, v => { g.n = v; }),
    slider('Inner edge', Math.round(g.r0 * 100), 0, 110, 1, v => { g.r0 = Math.min(v / 100, g.r1 - 0.02); }, v => v + '%'),
    slider('Outer edge', Math.round(g.r1 * 100), 2, 120, 1, v => { g.r1 = Math.max(v / 100, g.r0 + 0.02); }, v => v + '%'),
    slider('Turn', g.rot, 0, 359, 1, v => { g.rot = v; }, v => Math.round(v) + '°')];
  if (!m.cont || g.motif === 'zigzag') size.push(slider('Fill each space', Math.round(g.size * 100), 5, 100, 1, v => { g.size = v / 100; }, v => v + '%'));
  if (m.stroke) size.push(slider('Line weight', g.weight, 0.3, 12, 0.1, v => { g.weight = v; }, v => v.toFixed(1)));
  if (g.motif === 'spiral') size.push(slider('Twist', g.twist, -720, 720, 1, v => { g.twist = v; }, v => Math.round(v) + '°'));
  out.append(h('section', { class: 'ff-sec' }, titled('Size & position', TIPS.ringSize), ...size));
  out.append(h('section', { class: 'ff-sec' }, titled('Colour', TIPS.ringColour),
    seg([{ id: 'one', label: 'One paint' }, { id: 'alt', label: 'Alternate' }, { id: 'spectrum', label: 'Spectrum' }], g.mode, id => { g.mode = id; ui.ringPart = 0; changed(true); }, 'Colour mode'),
    note(g.mode === 'spectrum' ? 'Each shape gets the next colour along the paint (a gradient, or round the colour wheel from one colour).' : g.mode === 'alt' ? 'Pick Shapes A or Shapes B, then its colour. The shapes you are painting are outlined on the star.' : ''),
    g.mode === 'alt' ? altPaints(g) : paintPicker(g.fill, p => { g.fill = p; })));
  out.append(h('section', { class: 'ff-sec' }, titled('Extras', TIPS.ringExtras),
    check('Colour behind the shapes (a band)', !!g.bg, v => { g.bg = v ? '#1e1209' : null; changed(true); }),
    g.bg ? paintPicker(g.bg, p => { g.bg = p; }) : null,
    !m.stroke ? check('Outline each shape', !!g.outline, v => { g.outline = v ? { c: '#1e1209', w: 1.2 } : null; changed(true); }) : null,
    g.outline ? h('div', { class: 'ff-sub' }, paintPicker(g.outline.c, p => { g.outline.c = isHex(p) ? p : paintColors(p)[0]; }, { gradients: false }),
      slider('Outline width', g.outline.w, 0.2, 6, 0.1, v => { g.outline.w = v; }, v => v.toFixed(1))) : null,
    row(btn('Randomise this ring', () => { const r = rng(Date.now() & 0xffffffff); Object.assign(g, randomRing(r, pickPalette(r), g.r0, g.r1)); changed(true); }, 'is-quiet'))));
  return out;
}

/* Alternate colouring works like Points A / B: one set at a time, each chip showing its current colour */
function altPaints(g) {
  const part = ui.ringPart % 2;
  const chip = (k, label) => {
    const on = part === k, paint = k ? g.fill2 : g.fill;
    return h('button', { type: 'button', class: 'ff-chip ff-chip-paint' + (on ? ' is-on' : ''), 'aria-pressed': on ? 'true' : 'false',
      onclick: () => { ui.ringPart = k; refreshPanel(); requestRender(); } },
      h('span', { class: 'ff-dot', style: 'background:' + paintCss(paint) }), label);
  };
  return h('div', null,
    h('div', { class: 'ff-chips', role: 'group', 'aria-label': 'Which shapes to paint' }, chip(0, 'Shapes A'), chip(1, 'Shapes B'),
      h('button', { type: 'button', class: 'ff-chip', title: 'Swap the colours of A and B', onclick: () => { const t = g.fill; g.fill = g.fill2; g.fill2 = t; changed(true); } }, '⇄ Swap')),
    part ? paintPicker(g.fill2, p => { g.fill2 = p; }) : paintPicker(g.fill, p => { g.fill = p; }));
}

/* ── POINTS ── */
PANELS.points = function () {
  const d = curDesign(), P = d.points, wrap = h('div');
  wrap.append(h('section', { class: 'ff-sec' }, titled('Points', TIPS.points),
    h('p', { class: 'ff-lead' }, 'The 8 points of the star. Tap a point on the star, or pick one here.')));
  wrap.append(h('section', { class: 'ff-sec' }, titled('Edit', TIPS.pointFill), seg([{ id: 'all', label: 'All 8 together' }, { id: 'alt', label: 'Alternate' }, { id: 'each', label: 'Each point' }], P.link, id => {
    P.link = id;
    if (id === 'all') P.items.forEach((p, k) => { if (k) P.items[k] = deepClone(P.items[0]); });
    if (id === 'alt') P.items.forEach((p, k) => { if (k > 1) P.items[k] = deepClone(P.items[k % 2]); });
    ui.pointSel = id === 'all' ? 0 : ui.pointSel;
    ui.sel = { kind: 'point', ks: linkedPoints(ui.pointSel) }; changed(true);
  }, 'Points linked')));
  if (P.link !== 'all') {
    const choices = P.link === 'alt' ? [{ k: 0, l: 'Points A' }, { k: 1, l: 'Points B' }] : POINT_LABELS.map((l, k) => ({ k, l }));
    wrap.append(h('div', { class: 'ff-chips' }, choices.map(c => {
      const on = P.link === 'alt' ? ui.pointSel % 2 === c.k : ui.pointSel === c.k;
      return h('button', { type: 'button', class: 'ff-chip' + (on ? ' is-on' : ''), 'aria-pressed': on ? 'true' : 'false', onclick: () => { ui.pointSel = c.k; ui.sel = { kind: 'point', ks: linkedPoints(c.k) }; refreshPanel(); requestRender(); } }, c.l);
    })));
  }
  const k0 = P.link === 'all' ? 0 : ui.pointSel, p = P.items[k0];
  /* edits apply to every linked point */
  const edit = fn => { linkedPoints(k0).forEach(k => fn(P.items[k])); };
  wrap.append(section('Fill', seg([{ id: 'none', label: 'Show background' }, { id: 'paint', label: 'Colour' }, { id: 'pattern', label: 'Pattern' }], p.kind, id => { edit(q => { q.kind = id; }); changed(true); }, 'Point fill')));
  if (p.kind === 'paint') wrap.append(paintPicker(p.paint, np => edit(q => { q.paint = deepClone(np); })));
  if (p.kind === 'pattern') {
    if (p.url) wrap.append(slider('Pattern size', p.scale, 10, 400, 1, v => edit(q => { q.scale = v; }), v => Math.round(v) + '%'));
    wrap.append(libraryBrowser({ which: 'bg', current: p.url, onPick: (url, name) => { edit(q => { q.url = url; q.name = name; }); requestRender(); commit(); } }));
  }
  wrap.append(h('section', { class: 'ff-sec' }, titled('Symbol on the point', TIPS.pointSymbol),
    iconGrid([''].concat(POINT_MOTIFS), p.motif, id => id ? pointIcon(id) : '<svg viewBox="-1 -1 2 2"><path d="M-.6 -.6 L.6 .6" stroke="currentColor" stroke-width=".12"/></svg>',
      id => id ? id.charAt(0).toUpperCase() + id.slice(1) : 'None', id => { edit(q => { q.motif = id; }); changed(true); }, 'Point symbol'),
    p.motif ? [paintPicker(p.mpaint, np => edit(q => { q.mpaint = deepClone(np); })),
      slider('Symbol size', Math.round(p.msize * 100), 20, 160, 1, v => edit(q => { q.msize = v / 100; }), v => v + '%'),
      slider('Turn', p.mrot, 0, 359, 1, v => edit(q => { q.mrot = v; }), v => Math.round(v) + '°')] : null));
  wrap.append(section('Quick looks', row(
    btn('Rainbow points', () => { P.link = 'each'; P.items.forEach((q, k) => { q.kind = 'paint'; q.paint = samplePaint(gradPaint('rainbow'), k / 8); }); changed(true); }, 'is-quiet'),
    btn('Two-tone', () => { P.link = 'alt'; const a = '#e3a92b', b2 = '#1e1209'; P.items.forEach((q, k) => { q.kind = 'paint'; q.paint = k % 2 ? b2 : a; }); changed(true); }, 'is-quiet'),
    btn('Clear points', () => { d.points = makePoints(); ui.pointSel = 0; changed(true); }, 'is-quiet'))));
  return wrap;
};

/* ── ART (library overlays) ── */
PANELS.art = function () {
  const d = curDesign(), wrap = h('div'), i = selectedLayerIndex();
  const L = i >= 0 && d.layers[i].type === 'art' ? d.layers[i] : null;
  const ll = layersList(); if (ll) wrap.append(ll);
  wrap.append(row(btn('+ New art layer', () => { if (addLayer(makeArt()) >= 0) { refreshPanel(); requestRender(); } }, L ? 'is-quiet' : 'is-primary')));
  if (!L) {
    /* nothing selected: pick art straight away; a new layer is made for it */
    wrap.append(h('section', { class: 'ff-sec' }, titled('Add art', TIPS.art), note('Line art you can recolour, or full-colour pieces. Drag them on the star.'),
      libraryBrowser({ which: 'ov', current: '', onPick: (url, name) => {
        const A = makeArt(); A.url = url; A.name = name; A.tint = isColorOverlay(url) ? 'original' : 'hsb';
        if (addLayer(A) >= 0) { requestRender(); refreshPanel(); }
      } })));
    return wrap;
  }
  if (L.url) {
    const color = isColorOverlay(L.url);
    const tint = color ? [note('Full-colour art: shown in its own colours.')] : [
      seg([{ id: 'hsb', label: 'One colour' }, { id: 'paint', label: 'Gradient' }, { id: 'original', label: 'Original' }], L.tint, id => { L.tint = id; changed(true); }, 'Art colour'),
      L.tint === 'hsb' ? [slider('Hue', L.hue, 0, 360, 1, v => { L.hue = v; }, v => Math.round(v) + '°'), slider('Saturation', L.sat, 0, 100, 1, v => { L.sat = v; }, v => v + '%'),
        slider('Brightness', L.bri, 0, 200, 1, v => { L.bri = v; }, v => v + '%'), h('div', { class: 'ff-preview-chip', style: 'background:' + hsbToHsl(L.hue, L.sat, L.bri) })] : null,
      L.tint === 'paint' ? paintPicker(L.paint, p => { L.paint = p; }) : null];
    wrap.append(h('section', { class: 'ff-sec' }, titled(L.name || 'Art', TIPS.artColour), ...tint));
    wrap.append(h('section', { class: 'ff-sec' }, titled('Place it', TIPS.artPlace),
      seg([{ id: 'single', label: 'Single' }, { id: 'repeat', label: 'Repeat' }], L.mode, id => { L.mode = id; if (id === 'repeat' && L.scale > 60) L.scale = 30; changed(true); }, 'Layout'),
      slider('Size', L.scale, 5, 400, 1, v => { L.scale = v; }, v => Math.round(v) + '%'),
      slider('Turn', L.rot, 0, 359, 1, v => { L.rot = v; }, v => Math.round(v) + '°'),
      slider('Opacity', Math.round(L.opacity * 100), 5, 100, 1, v => { L.opacity = v / 100; }, v => v + '%'),
      row(check('Mirror', L.flip, v => { L.flip = v; changed(); }), btn('Centre', () => { L.x = 0; L.y = 0; changed(); }, 'is-quiet')),
      note('Drag on the star to move this layer.')));
  }
  wrap.append(section(L.url ? 'Choose other art' : 'Choose art', libraryBrowser({ which: 'ov', current: L.url, onPick: (url, name) => {
    L.url = url; L.name = name; if (isColorOverlay(url)) L.tint = 'original'; else if (L.tint === 'original') L.tint = 'hsb';
    requestRender(); commit(); refreshPanel();
  } })));
  wrap.append(row(btn('Duplicate layer', () => { const c = deepClone(L); c.x += 20; c.y += 20; addLayer(c); refreshPanel(); requestRender(); }, 'is-quiet'), btn('Delete layer', () => removeLayer(i), 'is-quiet')));
  return wrap;
};

/* ── TEXT ── */
let fontsLoaded = false;
function ensureFonts() {
  if (fontsLoaded) return;
  fontsLoaded = true;
  document.head.append(h('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?' + FONTS.map(f => 'family=' + f.replace(/ /g, '+')).join('&') + '&display=swap' }));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => requestRender());
}
PANELS.text = function () {
  ensureFonts();
  const d = curDesign(), wrap = h('div'), i = selectedLayerIndex();
  const T = i >= 0 && d.layers[i].type === 'text' ? d.layers[i] : null;
  const ll = layersList(); if (ll) wrap.append(ll);
  wrap.append(row(btn('+ Add text', () => { if (addLayer(makeText()) >= 0) { refreshPanel(); requestRender(); } }, T ? 'is-quiet' : 'is-primary')));
  if (!T) { wrap.append(note('Add a name, a word or a date. Curve it round the star or set it straight.')); return wrap; }
  const input = h('input', { type: 'text', class: 'ff-input ff-text-in', value: T.text, maxlength: String(MAX_TEXT_LEN), 'aria-label': 'Text', autocomplete: 'off' });
  input.addEventListener('input', () => { T.text = cleanText(input.value, MAX_TEXT_LEN); requestRender(); commitSoon(); });
  wrap.append(h('section', { class: 'ff-sec' }, titled('Text', TIPS.text), input, note('Printed exactly as typed, so check the spelling.')));
  const fonts = h('div', { class: 'ff-fonts' });
  FONTS.forEach(f => fonts.append(h('button', { type: 'button', class: 'ff-font' + (T.font === f ? ' is-on' : ''), style: "font-family:'" + f + "',sans-serif", 'aria-pressed': T.font === f ? 'true' : 'false',
    onclick: () => { T.font = f; changed(true); } }, f)));
  wrap.append(h('section', { class: 'ff-sec' }, titled('Font', TIPS.textFont), fonts));
  wrap.append(h('section', { class: 'ff-sec' }, titled('Shape', TIPS.textShape),
    seg([{ id: 'arc', label: 'Curved' }, { id: 'line', label: 'Straight' }], T.mode, id => { T.mode = id; changed(true); }, 'Text shape'),
    T.mode === 'arc' ? [slider('Curve size', Math.round(T.r * 100), 15, 98, 1, v => { T.r = v / 100; }, v => v + '%'), check('Along the bottom (reads upright)', T.flip, v => { T.flip = v; changed(); })] : null,
    slider('Text size', T.size, 6, 120, 1, v => { T.size = v; }),
    slider('Letter spacing', T.ls, -4, 30, 0.5, v => { T.ls = v; }),
    slider('Turn', T.rot, 0, 359, 1, v => { T.rot = v; }, v => Math.round(v) + '°'),
    T.mode === 'line' ? note('Drag on the star to move straight text.') : null));
  wrap.append(h('section', { class: 'ff-sec' }, titled('Colour', TIPS.textColour), paintPicker(T.paint, p => { T.paint = p; }),
    check('Outline', !!T.outline, v => { T.outline = v ? { c: '#1e1209', w: 2 } : null; changed(true); }),
    T.outline ? [paintPicker(T.outline.c, p => { T.outline.c = isHex(p) ? p : paintColors(p)[0]; }, { gradients: false }), slider('Outline width', T.outline.w, 0.2, 8, 0.1, v => { T.outline.w = v; }, v => v.toFixed(1))] : null));
  wrap.append(row(btn('Delete text', () => removeLayer(i), 'is-quiet')));
  return wrap;
};

/* ── 12-stage.js ── */
/* ── STAGE: the live star ── */
function stageSelection() {
  const s = ui.sel, d = curDesign();
  if (s.kind === 'point') return ui.tab === 'points' ? s : null;
  if (s.kind === 'wedge') return s;
  if (s.kind === 'layer') {
    const L = d.layers[s.i];
    if (!L) return null;
    if (L.type === 'mandala' && ui.tab === 'mandala' && L.rings.length) {
      const g = L.rings[L.sel || 0];
      return { kind: 'ring', layer: s.i, ring: L.sel || 0, part: g && g.mode === 'alt' ? ui.ringPart % 2 : null };
    }
    if (L.type === 'art' && ui.tab === 'art') return { kind: 'art', layer: s.i };
  }
  return null;
}
function renderStage() {
  const host = $('[data-ff-canvas]');
  if (!host) return;
  host.innerHTML = renderSide(curDesign(), {
    idp: 'st' + state.activeSide, mode: 'stage', side: state.activeSide,
    trim: ui.view.trim, hide: ui.hide,
    tips: ui.view.tips, uv: ui.view.uv, select: ui.view.detail ? null : stageSelection()
  });
  syncStageTools();
  ROOT.classList.toggle('is-uv', !!ui.view.uv);
  const hint = $('[data-ff-hint]');
  if (hint) hint.textContent = stageHint();
  if (ui.spinning) queueSpinRefresh();
}
function stageHint() {
  if (ui.view.detail) return 'Detail view: drag to look around. Nothing on the star is selected while it is on.';
  if (ui.tab === 'points') return 'Tap a point to edit it.';
  if (ui.tab === 'mandala') return curDesign().layers.some(L => L.type === 'mandala') ? 'Tap a ring to edit it.' : '';
  if (ui.tab === 'art' || ui.tab === 'text') { const L = selectedLayer(); return L && (L.type === 'art' || (L.type === 'text' && L.mode === 'line')) ? 'Drag on the star to move the selected layer.' : ''; }
  if (ui.view.trim || ui.view.tips) return 'Dark bands and white points show what the binding and GlowStar tips will cover.';
  return '';
}

/* pointer position in viewBox units */
function toVB(e) {
  const svg = $('[data-ff-canvas] svg');
  if (!svg) return null;
  const r = svg.getBoundingClientRect();
  if (!(r.width > 20)) return null;
  return { x: (e.clientX - r.left) * VB / r.width, y: (e.clientY - r.top) * VB / r.height, k: VB / r.width };
}
function pointInTri(p, a, b, c) {
  const s = (a.x - c.x) * (p.y - c.y) - (a.y - c.y) * (p.x - c.x), t = (b.x - a.x) * (p.y - a.y) - (b.y - a.y) * (p.x - a.x);
  if ((s < 0) !== (t < 0) && s !== 0 && t !== 0) return false;
  const dd = (c.x - b.x) * (p.y - b.y) - (c.y - b.y) * (p.x - b.x);
  return dd === 0 || (dd < 0) === (s + t <= 0);
}
function hitPoint(p) { for (let k = 0; k < 8; k++) if (pointInTri(p, INNER[(k + 7) % 8], OUTER[k], INNER[k])) return k; return -1; }
function distToSeg(p, a, b) {
  const dx = b.x - a.x, dy = b.y - a.y, t = Math.max(0, Math.min(1, ((p.x - a.x) * dx + (p.y - a.y) * dy) / (dx * dx + dy * dy)));
  return Math.hypot(p.x - a.x - t * dx, p.y - a.y - t * dy);
}
function hitRing(p, L) {
  /* the ring under the pointer, in the mandala's own (unturned) frame: radius is all that matters */
  const r = Math.hypot(p.x - CX, p.y - CY) / R;
  let hit = -1, area = 1e9;
  L.rings.forEach((g, j) => { if (!g.hidden && r >= g.r0 - 0.02 && r <= g.r1 + 0.02 && g.r1 - g.r0 < area) { hit = j; area = g.r1 - g.r0; } });
  if (hit >= 0 || !p.coarse) return hit;
  /* fingers are wide: on touch screens a tap just outside a thin ring still picks the nearest one */
  let best = 0.07;
  L.rings.forEach((g, j) => { if (g.hidden) return; const dd = r < g.r0 ? g.r0 - r : r - g.r1; if (dd < best) { best = dd; hit = j; } });
  return hit;
}
/* touch: a tap outside every point triangle (in a notch, or just past a tip) picks the point nearest by angle */
function nearestPoint(p) {
  const ang = (Math.atan2(p.x - CX, CY - p.y) * 180 / Math.PI + 360) % 360;
  return Math.round(ang / 45) % 8;
}

function wireStage() {
  const stage = $('[data-ff-stage]');
  let drag = null, queued = false;
  let tap = null;
  stage.addEventListener('pointerdown', e => {
    tap = null;
    if (ui.spinning || ui.view.detail || e.button > 0) return;
    const p = toVB(e);
    if (!p) return;
    p.coarse = e.pointerType === 'touch' || e.pointerType === 'pen';
    const d = curDesign(), L = selectedLayer();
    if ((ui.tab === 'art' && L && L.type === 'art' && L.url) || (ui.tab === 'text' && L && L.type === 'text' && L.mode === 'line')) {
      if (L.locked) return;
      drag = { x: e.clientX, y: e.clientY, ox: L.x, oy: L.y, k: p.k, L, moved: false };
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
      return;
    }
    /* everything else selects on release, and only if the finger did not move: starting a page scroll on
       the star no longer picks whatever was under the finger */
    tap = { x: e.clientX, y: e.clientY, t: Date.now(), p };
  });
  function tapSelect(p) {
    const d = curDesign();
    if (ui.tab === 'points') {
      let k = hitPoint(p);
      if (k < 0 && p.coarse && Math.hypot(p.x - CX, p.y - CY) > RIN_APOTHEM * 0.85 && Math.hypot(p.x - CX, p.y - CY) < R * 1.12) k = nearestPoint(p);
      if (k >= 0) { ui.pointSel = k; ui.sel = { kind: 'point', ks: linkedPoints(k) }; refreshPanel(); requestRender(); }
      return;
    }
    if (ui.tab === 'mandala') {
      const i = selectedLayerIndex(), M = i >= 0 ? d.layers[i] : null;
      if (M && M.type === 'mandala') { const j = hitRing(p, M); if (j >= 0) { M.sel = j; refreshPanel(); requestRender(); } }
      return;
    }
    if (ui.tab === 'background' && ui.sel.kind === 'wedge') {
      const ang = (Math.atan2(p.x - CX, CY - p.y) * 180 / Math.PI + 360 + 22.5) % 360;
      ui.sel = { kind: 'wedge', i: Math.floor(ang / 45) }; refreshPanel(); requestRender();
    }
  }
  stage.addEventListener('pointermove', e => {
    if (tap && Math.hypot(e.clientX - tap.x, e.clientY - tap.y) > 10) tap = null;
    if (!drag) return;
    drag.moved = true;
    drag.L.x = clampNum(drag.ox + (e.clientX - drag.x) * drag.k, -VB, VB, 0);
    drag.L.y = clampNum(drag.oy + (e.clientY - drag.y) * drag.k, -VB, VB, 0);
    if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; renderStage(); }); }
  });
  const end = () => { if (drag && drag.moved) commit(); drag = null; };
  stage.addEventListener('pointerup', e => {
    end();
    const t = tap; tap = null;
    if (t && Date.now() - t.t < 700 && Math.hypot(e.clientX - t.x, e.clientY - t.y) <= 10) tapSelect(t.p);
  });
  stage.addEventListener('pointercancel', () => { tap = null; end(); });
}

/* ── VIEW: zoom, blacklight, trim, GlowStar tips, Flow (spin) ── */
function setZoom(z) {
  ui.view.zoom = clampNum(z, 1, 4, 1);
  const c = $('[data-ff-canvas]');
  c.style.setProperty('--ff-zoom', ui.view.zoom);
  ROOT.classList.toggle('is-zoomed', ui.view.zoom > 1);
  const out = $('[data-ff-zoomval]');
  if (out) out.textContent = Math.round(ui.view.zoom * 100) + '%';
}
function toggleView(k) {
  if (k === 'flow') { ui.spinning ? stopSpin() : startSpin(); syncChrome(); return; }
  if (k === 'detail') { toggleDetail(); return; }
  ui.view[k] = !ui.view[k];
  requestRender();
}
const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/* Flow it: the star is turned by script each frame (not a CSS animation, which the reduced-motion
   rule pinned to one speed). Speed is in turns per second; the trail behind it is the angle the star
   covers in ~1/12 s, which is roughly what the eye smears into a streak, so faster spins blur more. */
let spinTimer = 0, spinBusy = false, spinRaf = 0, spinAngle = 0, spinLast = 0;
const SPIN_TRAILS = 5, SPIN_PERSIST = 1 / 12, SPIN_MAX_TRAIL = 150;
function spinFrame(now) {
  if (!ui.spinning) { spinRaf = 0; return; }
  /* reduced motion: same slider, one sixth the speed (as the old CSS version did), and no trail copies */
  const dt = spinLast ? Math.min(0.1, (now - spinLast) / 1000) : 0, speed = (ui.spinSpeed || 1) / (reduceMotion ? 6 : 1);
  spinLast = now;
  spinAngle = (spinAngle + speed * 360 * dt) % 360;
  const trail = Math.min(SPIN_MAX_TRAIL, speed * 360 * SPIN_PERSIST);
  ROOT.querySelectorAll('.ff-spin-img').forEach((img, i) => {
    img.style.transform = 'rotate(' + (spinAngle - trail * i / SPIN_TRAILS).toFixed(2) + 'deg)';
  });
  spinRaf = requestAnimationFrame(spinFrame);
}
async function startSpin() {
  ui.spinning = true;
  ROOT.classList.add('is-spinning');
  await paintSpin();
}
async function paintSpin() {
  if (spinBusy) return;
  spinBusy = true;
  const box = $('[data-ff-spin]');
  try {
    const c = await sideCanvas(state.activeSide, 720, 'print');
    if (!ui.spinning) return;
    const src = c.toDataURL('image/png');
    box.textContent = '';
    /* the star plus fading copies trailing behind it: what the eye sees when a star is flowed */
    for (let i = 0; i <= (reduceMotion ? 0 : SPIN_TRAILS); i++) {
      box.append(h('img', { src, alt: i ? '' : 'Your star spinning', class: 'ff-spin-img', style: 'opacity:' + (i ? (0.5 * (1 - i / (SPIN_TRAILS + 1))).toFixed(2) : '1') }));
    }
    box.hidden = false;
    if (!spinRaf) { spinLast = 0; spinRaf = requestAnimationFrame(spinFrame); }
  } catch (e) {
    stopSpin(); toast('Could not start the spin preview.');
  } finally { spinBusy = false; }
}
function queueSpinRefresh() { clearTimeout(spinTimer); spinTimer = setTimeout(() => { if (ui.spinning) paintSpin(); }, 700); }
function stopSpin() {
  ui.spinning = false;
  if (spinRaf) { cancelAnimationFrame(spinRaf); spinRaf = 0; }
  ROOT.classList.remove('is-spinning');
  const box = $('[data-ff-spin]');
  box.hidden = true; box.textContent = '';
}
function setSpinSpeed(v) {
  ui.spinSpeed = clampNum(v, 0.1, 3, 1);
  const out = $('[data-ff-speedval]');
  if (out) out.textContent = ui.spinSpeed.toFixed(1) + ' turns/s';
}
/* switching sides turns the star over */
function flipAnimation() {
  const c = $('[data-ff-canvas]');
  if (!c || reduceMotion || !c.animate) return;
  c.animate([{ transform: 'perspective(900px) rotateY(0deg) scale(var(--ff-zoom,1))', opacity: 1 },
    { transform: 'perspective(900px) rotateY(90deg) scale(var(--ff-zoom,1))', opacity: 0.4, offset: 0.45 },
    { transform: 'perspective(900px) rotateY(0deg) scale(var(--ff-zoom,1))', opacity: 1 }], { duration: 360, easing: 'cubic-bezier(0.23,1,0.32,1)' });
}

/* ── 13-looks.js ── */
/* ── LOOKS + SURPRISE ME ──
   The generator is seeded (same seed, same design) and draws only from hand-tuned palettes and motif
   families, so every roll is a coherent design rather than noise. It writes plain ring settings into
   the design, so a saved design never depends on the generator's code. */
function ring(motif, o) { return Object.assign(makeRing(motif), o); }
function grad(t, a, colors) { return { t, a, s: colors.map((c, i) => [round(i / (colors.length - 1), 3), c]) }; }
function withMandala(d, rings, extra) { const M = makeMandala(); M.rings = rings; Object.assign(M, extra || {}); d.layers.push(M); return d; }
function paintPoints(d, link, a, b) { d.points.link = link; d.points.items.forEach((p, k) => { p.kind = 'paint'; p.paint = (k % 2 && b) ? b : a; }); return d; }

const LOOKS = [
  { name: 'Hypno spin', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = '#0d0d0d';
    withMandala(d, [ring('spiral', { n: 12, r0: 0, r1: 1.02, twist: 210, size: 1, mode: 'alt', fill: '#f7f4ee', fill2: '#0d0d0d' }),
      ring('band', { r0: 0, r1: 0.1, fill: '#d81e2a' })]);
    return paintPoints(d, 'alt', '#d81e2a', '#0d0d0d');
  } },
  { name: 'Moon garden', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = grad('radial', 0, ['#3a1d78', '#0b1033']);
    withMandala(d, [ring('petals', { n: 8, r0: 0, r1: 0.22, fill: '#ffd36e' }), ring('lace', { n: 16, r0: 0.24, r1: 0.36, size: 0.9, weight: 1.2, fill: '#e9f1ff' }),
      ring('moons', { n: 12, r0: 0.42, r1: 0.6, size: 0.8, fill: '#e9f1ff' }), ring('scallops', { n: 16, r0: 0.64, r1: 0.74, size: 1, fill: '#8f3fd1' })]);
    d.points.items.forEach(p => { p.kind = 'paint'; p.paint = '#0b1033'; p.motif = 'moon'; p.mpaint = '#ffd36e'; p.msize = 1.1; });
    return d;
  } },
  { name: 'Sunburst', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = grad('sweep', 0, ['#7a1f4b', '#e0424b', '#ff8a3d', '#ffd166', '#ff8a3d', '#e0424b', '#7a1f4b']);
    withMandala(d, [ring('rays', { n: 24, r0: 0, r1: 0.42, size: 0.7, mode: 'alt', fill: '#ffd166', fill2: '#fff3d6' }), ring('keys', { n: 32, r0: 0.45, r1: 0.55, size: 0.6, fill: '#2b0f2e' }),
      ring('spikes', { n: 16, r0: 0.58, r1: 0.74, size: 0.9, fill: '#fff3d6' })]);
    d.points.items.forEach(p => { p.kind = 'paint'; p.paint = grad('radial', 0, ['#ffd166', '#e0424b']); });
    return d;
  } },
  { name: 'Neon rave', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = '#0b0716';
    withMandala(d, [ring('stars', { n: 8, r0: 0, r1: 0.18, size: 0.9, mode: 'spectrum', fill: gradPaint('rainbow') }),
      ring('zigzag', { n: 16, r0: 0.22, r1: 0.3, weight: 2.6, fill: '#ff2bd6' }), ring('dots', { n: 24, r0: 0.34, r1: 0.42, size: 0.8, mode: 'spectrum', fill: gradPaint('rainbow') }),
      ring('waves', { n: 8, r0: 0.46, r1: 0.56, weight: 2.4, fill: '#2bf0ff' }), ring('rays', { n: 16, r0: 0.6, r1: 0.74, size: 0.5, fill: '#c6ff2b' })]);
    d.points.link = 'each';
    d.points.items.forEach((p, k) => { p.kind = 'paint'; p.paint = samplePaint(gradPaint('rainbow'), k / 8); });
    return d;
  } },
  { name: 'Op art', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = '#f7f4ee';
    withMandala(d, [ring('checker', { n: 16, r0: 0, r1: 0.2, size: 1, fill: '#0d0d0d' }), ring('keys', { n: 24, r0: 0.22, r1: 0.4, size: 0.5, fill: '#0d0d0d' }),
      ring('teeth', { n: 16, r0: 0.43, r1: 0.55, size: 1, mode: 'alt', fill: '#0d0d0d', fill2: '#f7f4ee' }), ring('band', { r0: 0.57, r1: 0.6, fill: '#0d0d0d' }),
      ring('spiral', { n: 16, r0: 0.62, r1: 0.95, twist: 60, size: 0.5, fill: '#0d0d0d' })]);
    return paintPoints(d, 'alt', '#0d0d0d', '#f7f4ee');
  } },
  { name: 'Galaxy kaleidoscope', build() {
    const d = makeDesign();
    Object.assign(d.base, { kind: 'kaleido', url: keyToUrl('30K Seamless Pack/011_Space & Galaxy & Planet_(576)/001_Space & Galaxy & Planet.jpg'), name: 'Space & Galaxy & Planet 001', scale: 140, folds: 8 });
    withMandala(d, [ring('lace', { n: 12, r0: 0.08, r1: 0.22, size: 0.95, weight: 1.1, fill: '#e9f1ff' }), ring('dots', { n: 32, r0: 0.66, r1: 0.7, size: 0.7, fill: '#ffd36e' })]);
    return d;
  } },
  { name: 'Boho sun', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = '#f1e3c8';
    withMandala(d, [ring('petals', { n: 12, r0: 0, r1: 0.24, size: 0.9, mode: 'alt', fill: '#b5651d', fill2: '#d9a441' }), ring('dots', { n: 24, r0: 0.27, r1: 0.32, size: 0.8, fill: '#6b3f1d' }),
      ring('scallops', { n: 16, r0: 0.35, r1: 0.47, size: 1, fill: '#d9a441', outline: { c: '#6b3f1d', w: 1 } }), ring('leaves', { n: 16, r0: 0.5, r1: 0.66, fill: '#8a9a5b' })]);
    d.points.items.forEach(p => { p.kind = 'paint'; p.paint = '#b5651d'; p.motif = 'leaf'; p.mpaint = '#f1e3c8'; });
    return d;
  } },
  { name: 'Fire dancer', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = grad('radial', 0, ['#ffb300', '#d62600', '#1a0500']);
    withMandala(d, [ring('flames', { n: 8, r0: 0, r1: 0.3, size: 0.9, fill: '#fff2b3' }), ring('flames', { n: 16, r0: 0.34, r1: 0.62, size: 0.8, rot: 11.25, mode: 'alt', fill: '#ffb300', fill2: '#ff6a00' }),
      ring('spikes', { n: 32, r0: 0.64, r1: 0.74, size: 0.8, fill: '#1a0500' })]);
    d.points.items.forEach(p => { p.kind = 'paint'; p.paint = '#7a0c00'; p.motif = 'flame'; p.mpaint = grad('linear', 90, ['#ffe066', '#ff6a00']); });
    return d;
  } },
  { name: 'Deep ocean', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = grad('radial', 0, ['#0f8fa3', '#03142b']);
    withMandala(d, [ring('bubbles', { n: 8, r0: 0, r1: 0.16, size: 0.9, fill: '#bff7ee' }), ring('waves', { n: 12, r0: 0.2, r1: 0.3, weight: 2, fill: '#3fd6c9' }),
      ring('drops', { n: 16, r0: 0.34, r1: 0.52, size: 0.8, mode: 'spectrum', fill: grad('linear', 0, ['#3fd6c9', '#bff7ee', '#0f8fa3']) }), ring('waves', { n: 16, r0: 0.56, r1: 0.64, weight: 1.6, fill: '#bff7ee' })]);
    return paintPoints(d, 'alt', '#0a4a6e', '#0f8fa3');
  } },
  { name: 'Royal gold', build() {
    const d = makeDesign(); d.base.kind = 'paint'; d.base.paint = '#1e1209';
    withMandala(d, [ring('petals', { n: 8, r0: 0, r1: 0.26, size: 0.95, fill: grad('radial', 0, ['#fff3b0', '#e3a92b']), outline: { c: '#1e1209', w: 1 } }),
      ring('stars', { n: 16, r0: 0.3, r1: 0.38, size: 0.7, fill: '#f0c25a' }), ring('frame', { n: 8, r0: 0.42, r1: 0.46, rot: 22.5, fill: '#e3a92b' }),
      ring('scrolls', { n: 16, r0: 0.5, r1: 0.64, weight: 1.6, fill: '#e3a92b' })]);
    d.points.items.forEach(p => { p.kind = 'paint'; p.paint = grad('radial', 0, ['#7a1f2b', '#3b2410']); p.motif = 'star'; p.mpaint = '#f0c25a'; p.msize = 0.8; });
    return d;
  } }
];
const lookCache = {};
function lookDesign(look) { return lookCache[look.name] || (lookCache[look.name] = look.build()); }
function applyLook(look) {
  stopSpin();
  state.designs[state.activeSide] = deepClone(look.build());
  ui.sel = { kind: 'base' };
  commit(); requestRender();
  toast(look.name + ' applied. Now make it yours.', 'Undo', () => { undo(); refreshPanel(); requestRender(); });
}

/* ── GENERATOR ── */
function pickPalette(r, vibeId) {
  const id = vibeId && VIBES[vibeId] ? vibeId : r.pick(Object.keys(VIBES));
  const v = VIBES[id];
  return { id, ground: v.ground, colors: r.shuffle(v.colors), all: [v.ground].concat(v.colors) };
}
function randomPaint(r, pal, allowGrad) {
  if (allowGrad && r.chance(0.3)) {
    const a = r.pick(pal.colors), b = r.pick(pal.colors.filter(c => c !== a));
    return { t: r.pick(['linear', 'radial', 'sweep']), a: r.int(0, 359), s: [[0, a], [1, b]] };
  }
  return r.pick(pal.colors);
}
const RING_FAMILIES = {
  center: ['petals', 'rays', 'dots', 'bubbles', 'spiral', 'stars', 'flames'],
  mid: ['keys', 'dots', 'scallops', 'lace', 'waves', 'moons', 'petals', 'teeth', 'checker', 'diamonds', 'hearts', 'leaves', 'curls', 'scrolls', 'zigzag', 'eyes', 'spiral', 'drops', 'rays'],
  edge: ['rays', 'spikes', 'teeth', 'frame', 'scallops', 'flames', 'petals', 'band', 'chevrons']
};
function randomRing(r, pal, r0, r1, family) {
  const motif = r.pick(RING_FAMILIES[family || 'mid']), m = MOTIFS[motif], g = makeRing(motif);
  g.r0 = r0; g.r1 = r1;
  /* multiples of 8 echo the star's own symmetry */
  g.n = m.cont ? r.pick([6, 8, 12, 16]) : r.pick([8, 12, 16, 16, 24, 32]);
  g.rot = r.chance(0.5) ? 0 : round(180 / g.n, 2);
  g.size = round(r.range(0.55, 0.95), 2);
  g.weight = round(r.range(1.4, 3.2), 1);
  g.twist = r.pick([-180, -120, 120, 180, 240]);
  const roll = r.next();
  g.mode = roll < 0.55 ? 'one' : roll < 0.85 ? 'alt' : 'spectrum';
  g.fill = g.mode === 'spectrum' ? (r.chance(0.5) ? gradPaint('rainbow') : grad('linear', 0, pal.colors)) : randomPaint(r, pal, true);
  g.fill2 = randomPaint(r, pal, false);
  g.bg = r.chance(0.22) ? r.pick(pal.all) : null;
  g.outline = (!m.stroke && r.chance(0.2)) ? { c: pal.ground, w: round(r.range(0.6, 1.6), 1) } : null;
  return g;
}
function generateRings(r, pal) {
  const count = r.int(3, 6), outer = r.range(0.62, 0.98), ws = [];
  for (let i = 0; i < count; i++) ws.push(i === 0 ? r.range(0.8, 1.4) : r.range(0.6, 1.2));
  const sum = ws.reduce((a, b) => a + b, 0), rings = [];
  let at = 0;
  ws.forEach((w, i) => {
    const span = outer * w / sum, gap = i ? r.range(0, 0.025) : 0;
    rings.push(randomRing(r, pal, round(at + gap, 3), round(at + span, 3), i === 0 ? 'center' : i === count - 1 ? 'edge' : 'mid'));
    at += span;
  });
  rings[0].r0 = 0;
  return rings;
}
function starterRings() {
  return [ring('petals', { n: 8, r0: 0, r1: 0.24, fill: '#e3a92b' }), ring('dots', { n: 16, r0: 0.28, r1: 0.36, fill: '#fbf6ec' }), ring('rays', { n: 16, r0: 0.4, r1: 0.6, size: 0.6, fill: '#e3a92b' })];
}
const VIBE_THEMES = { neon: 'Psychedelic & Retro', cosmic: 'Nature, Animals & Space', sunset: 'Abstract & Artistic', ocean: 'Textures & Materials', earth: 'Cultural & Vintage',
  hypno: 'Geometric & Optical', candy: 'Cute & Kids', fire: 'Abstract & Artistic', forest: 'Floral & Botanical', royal: 'Cultural & Vintage' };
function surpriseMe() {
  stopSpin();
  const seed = (Math.random() * 2147483647) >>> 0;
  ui.lastSeed = seed;
  const r = rng(seed), vibe = ui.vibe && ui.vibe !== 'any' ? ui.vibe : null, pal = pickPalette(r, vibe), d = curDesign();
  loadManifest('bg').catch(() => {}); loadManifest('ov').catch(() => {});
  if (!ui.locks.background) {
    const roll = r.next();
    const f = LIB.bg && roll >= 0.45 ? randomFile('bg', r, VIBE_THEMES[pal.id]) || randomFile('bg', r) : null;
    if (!f) { d.base = Object.assign(makeBase(), { kind: 'paint', paint: r.chance(0.45) ? pal.ground : { t: r.pick(['radial', 'sweep', 'linear']), a: r.int(0, 359), s: [[0, pal.ground], [1, r.pick(pal.colors)]] } }); }
    else d.base = Object.assign(makeBase(), { kind: roll < 0.78 ? 'pattern' : 'kaleido', url: f.url, name: f.name, scale: r.pick([50, 75, 100, 150]), folds: r.pick([8, 8, 16, 12]) });
    d.wedges = makeWedges();
  }
  if (!ui.locks.mandala) {
    d.layers = d.layers.filter(L => L.type !== 'mandala');
    if (r.chance(0.88)) { const M = makeMandala(); M.rings = generateRings(r, pal); d.layers.unshift(M); }
  }
  if (!ui.locks.points) {
    d.points = makePoints();
    const roll = r.next();
    if (roll < 0.7) {
      d.points.link = r.chance(0.6) ? 'alt' : 'all';
      const a = randomPaint(r, pal, true), b = randomPaint(r, pal, false);
      d.points.items.forEach((p, k) => { p.kind = 'paint'; p.paint = deepClone(d.points.link === 'alt' && k % 2 ? b : a); });
      if (r.chance(0.35)) { const m = r.pick(POINT_MOTIFS), mp = r.pick(pal.colors); d.points.items.forEach(p => { p.motif = m; p.mpaint = mp; }); }
    }
  }
  if (!ui.locks.art) {
    d.layers = d.layers.filter(L => L.type === 'mandala');
    if (LIB.ov && r.chance(0.3)) {
      const f = randomFile('ov', r);
      if (f) { const A = makeArt(); Object.assign(A, { url: f.url, name: f.name, mode: r.chance(0.4) ? 'repeat' : 'single', scale: r.pick([30, 45, 60, 90]), tint: isColorOverlay(f.url) ? 'original' : 'hsb', hue: hexToHsl(r.pick(pal.colors))[0], sat: 90, bri: 110, opacity: 0.85 }); d.layers.push(A); }
    }
  }
  ui.sel = { kind: 'base' };
  commit(); refreshPanel(); requestRender();
  toast('Fresh design (' + VIBES[pal.id].label + ').', 'Undo', () => { undo(); refreshPanel(); requestRender(); });
}

/* ── 14-workspace.js ── */
/* ── WORKSPACE: tools on the star itself, reachable from every tab ──
   top-left  "Layers & logo": hide (view only) or clear each major part, logo size / opacity
   top-right "Clear all": blank canvas, with Undo
   bottom-right "Detail": zoomed look-around view that never selects anything (made for phones)
   plus Saved designs (this browser) with backups that cannot get lost (email, file, link). */
const MAJOR = [
  { id: 'background', label: 'Background' },
  { id: 'mandala', label: 'Mandala' },
  { id: 'points', label: 'Points' },
  { id: 'art', label: 'Art' },
  { id: 'text', label: 'Text' }
];
function majorHas(d, id) {
  if (id === 'background') return d.base.kind === 'paint' || !!d.base.url || d.wedges.some(w => w.enabled);
  if (id === 'points') return d.points.items.some(p => p.kind !== 'none' || p.motif);
  return d.layers.some(L => L.type === id);
}
/* replace this side, refresh, and offer Undo (restores the side as it was) */
function replaceSide(fn, msg) {
  const side = state.activeSide, keep = deepClone(state.designs[side]);
  stopSpin();
  fn(state.designs[side]);
  ui.sel = { kind: 'base' };
  commit(); refreshPanel(); requestRender(); refreshLayersPop();
  toast(msg, 'Undo', () => { state.designs[side] = keep; commit(); refreshPanel(); requestRender(); refreshLayersPop(); });
}
function clearMajor(id) {
  const label = MAJOR.find(m => m.id === id).label;
  ui.hide[id] = false;
  replaceSide(d => {
    if (id === 'background') { d.base = makeBase(); d.wedges = makeWedges(); }
    else if (id === 'points') { d.points = makePoints(); ui.pointSel = 0; }
    else d.layers = d.layers.filter(L => L.type !== id);
  }, label + ' cleared.');
}
/* blank canvas = the whole side cleared (logo settings kept), starting on the Background tab */
function blankCanvas() {
  ui.hide = {};
  replaceSide(d => { const fresh = makeDesign(); fresh.logoPct = d.logoPct; fresh.logoOp = d.logoOp; Object.assign(d, fresh); },
    state.numSides === 2 ? 'Side ' + (state.activeSide + 1) + ' is blank. Start with a background.' : 'Blank canvas. Start with a background.');
  setTab('background');
}
function toggleHide(id) { ui.hide[id] = !ui.hide[id]; requestRender(); refreshLayersPop(); }

/* ── Layers & logo menu ── */
function layersPop() { return $('[data-ff-layerpop]'); }
function openLayersPop(open) {
  const pop = layersPop();
  if (!pop) return;
  pop.hidden = open == null ? !pop.hidden : !open;
  const b = $('[data-act="layers"]');
  if (b) b.setAttribute('aria-expanded', pop.hidden ? 'false' : 'true');
  if (!pop.hidden) refreshLayersPop();
}
function refreshLayersPop() {
  const pop = layersPop();
  if (!pop || pop.hidden) return;
  const d = curDesign();
  const eye = (id, label) => h('button', { type: 'button', class: 'ff-mini' + (ui.hide[id] ? ' is-off' : ''), 'aria-pressed': ui.hide[id] ? 'true' : 'false',
    'aria-label': (ui.hide[id] ? 'Show ' : 'Hide ') + label, title: ui.hide[id] ? 'Show (view only)' : 'Hide (view only)', onclick: () => toggleHide(id) }, ui.hide[id] ? '◌' : '◉');
  pop.textContent = '';
  pop.append(h('div', { class: 'ff-pop-head' }, h('strong', null, 'Layers & logo'),
    h('button', { type: 'button', class: 'ff-mini', 'aria-label': 'Close', onclick: () => openLayersPop(false) }, '✕')));
  const list = h('ul', { class: 'ff-pop-list' });
  MAJOR.forEach(m => {
    const has = majorHas(d, m.id);
    list.append(h('li', { class: 'ff-pop-row' + (ui.hide[m.id] ? ' is-hidden' : '') },
      h('button', { type: 'button', class: 'ff-pop-name', onclick: () => { openLayersPop(false); setTab(m.id); } }, m.label, has ? null : h('small', null, ' empty')),
      eye(m.id, m.label),
      h('button', { type: 'button', class: 'ff-mini', 'aria-label': 'Clear ' + m.label, title: 'Clear ' + m.label, disabled: has ? null : true, onclick: () => clearMajor(m.id) }, '🗑')));
  });
  pop.append(list);
  pop.append(h('div', { class: 'ff-pop-logo' },
    h('div', { class: 'ff-pop-row' }, h('span', { class: 'ff-pop-name' }, 'Brain Plague Designs logo'), eye('logo', 'logo')),
    slider('Logo size', d.logoPct, LOGO_MIN, LOGO_MAX, 1, v => { d.logoPct = v; }, v => v + '%'),
    slider('Logo opacity', d.logoOp, LOGO_OP_MIN, 100, 5, v => { d.logoOp = v; }, v => v + '%'),
    note('Every star carries the logo in the centre. You can shrink it or let your design show through it.')));
  pop.append(note('Hiding only changes your view while you design. Hidden parts are still printed.'));
  pop.append(btn('Clear everything (blank canvas)', () => { openLayersPop(false); blankCanvas(); }, 'is-quiet ff-pop-clear'));
}
/* corner badges, called after every stage render */
function syncStageTools() {
  const n = Object.keys(ui.hide).filter(k => ui.hide[k]).length;
  const badge = $('[data-ff-hidden]');
  if (badge) {
    badge.hidden = !n;
    badge.textContent = n === 1 ? '1 part hidden · show' : n + ' parts hidden · show all';
  }
}

/* ── Detail view: zoomed in, drag to look around, taps never select ── */
function toggleDetail(on) {
  ui.view.detail = on == null ? !ui.view.detail : !!on;
  if (ui.view.detail) stopSpin();
  ROOT.classList.toggle('is-detail', ui.view.detail);
  setZoom(ui.view.detail ? 2.5 : 1);
  requestRender();
  /* the stage grows on phones: re-measure so the tabs pin below it, then centre the view */
  requestAnimationFrame(() => {
    syncSticky();
    const st = $('[data-ff-stage]');
    if (st) { st.scrollLeft = (st.scrollWidth - st.clientWidth) / 2; st.scrollTop = (st.scrollHeight - st.clientHeight) / 2; }
  });
}

/* ── SAVED DESIGNS ──
   This browser keeps up to 30 named designs (design codes, a few KB each). Browsers can clear storage, so the
   dialog also offers backups that live outside it: email the link to yourself, download a file, copy the link. */
const SAVES_KEY = 'flowforge:saved', MAX_SAVES = 30;
function readSaves() {
  const a = lsGet(SAVES_KEY, []);
  return Array.isArray(a) ? a.filter(s => s && typeof s.code === 'string' && /^SF[12]:/.test(s.code) && typeof s.id === 'string').slice(0, MAX_SAVES) : [];
}
function writeSaves(a) { try { localStorage.setItem(SAVES_KEY, JSON.stringify(a.slice(0, MAX_SAVES))); return true; } catch (e) { return false; } }
function defaultSaveName() { return 'My star ' + new Date().toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
function saveDesign(name, asNew) {
  const saves = readSaves(), code = designCode(), clean = cleanName(name).slice(0, 40) || defaultSaveName();
  let s = !asNew && ui.savedId ? saves.find(x => x.id === ui.savedId) : null;
  if (s) { s.name = clean; s.code = code; s.t = Date.now(); saves.splice(saves.indexOf(s), 1); saves.unshift(s); }
  else {
    if (saves.length >= MAX_SAVES) { toast('You have ' + MAX_SAVES + ' saved designs. Delete one first, or download a file instead.'); return false; }
    s = { id: 't' + Date.now().toString(36) + Math.floor(Math.random() * 1e6).toString(36), name: clean, code, t: Date.now() };
    saves.unshift(s);
  }
  if (!writeSaves(saves)) { toast('This browser would not save it (private mode or storage full). Download a file instead.'); return false; }
  ui.savedId = s.id; ui.savedName = s.name;
  toast('Saved “' + s.name + '” on this device.');
  return true;
}
function openCode(code, name, id) {
  stopSpin();
  applyDecoded(decodeDesignCode(code));
  ui.savedId = id || ''; ui.savedName = name || '';
  ui.hide = {};
  commit(); refreshPanel(true); requestRender();
  toast(name ? 'Opened “' + name + '”.' : 'Design opened.', 'Undo', () => { if (undo()) { refreshPanel(); requestRender(); } });
}
function backupText(name) {
  return 'FlowForge design: ' + name + '\nSaved: ' + new Date().toLocaleString() +
    '\n\nOpen this link to keep designing:\n' + shareLink() +
    '\n\nOr open FlowForge, press Save, then "Open a file" and pick this file.\n\nDesign code:\n' + designCode() + '\n';
}
function downloadBackup(name) {
  const blob = new Blob([backupText(name)], { type: 'text/plain' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = 'FlowForge - ' + (name.replace(/[^\w \-]+/g, '').trim() || 'design') + '.txt';
  document.body.append(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  toast('Downloaded. Open that file in FlowForge any time, on any device.');
}
function emailBackup(name) {
  const link = shareLink();
  const body = 'Open my FlowForge design again:\n' + link + '\n';
  location.href = 'mailto:?subject=' + encodeURIComponent('My FlowForge design: ' + name) + '&body=' + encodeURIComponent(body);
  if (link.length > 1800) toast('Big design: if the email arrives cut off, use Download file instead.');
}
function codeFromText(t) { const m = String(t || '').match(/SF[12]:[A-Za-z0-9_\-]+/); return m ? m[0] : ''; }

function savesDialog() { return $('[data-ff-saves]'); }
function openSaves(open) {
  const dlg = savesDialog();
  if (!dlg) return;
  dlg.hidden = !open;
  if (open) { buildSaves(); const f = dlg.querySelector('input'); if (f) f.focus(); }
}
function buildSaves() {
  const dlg = savesDialog(), box = dlg.querySelector('[data-ff-saves-body]');
  box.textContent = '';
  const nameIn = h('input', { type: 'text', class: 'ff-input', value: ui.savedName || defaultSaveName(), maxlength: '40', 'aria-label': 'Design name' });
  const after = () => buildSaves();
  box.append(h('section', { class: 'ff-sec' }, h('h3', { class: 'ff-sec-title' }, 'Save on this device'),
    nameIn,
    row(ui.savedId
      ? [btn('Update “' + (ui.savedName || 'design') + '”', () => { if (saveDesign(nameIn.value)) after(); }, 'is-primary'), btn('Save as new', () => { if (saveDesign(nameIn.value, true)) after(); })]
      : btn('Save', () => { if (saveDesign(nameIn.value, true)) after(); }, 'is-primary')),
    note('Saved designs stay in this browser. Your work also saves itself as you go.')));
  box.append(h('section', { class: 'ff-sec' }, h('h3', { class: 'ff-sec-title' }, 'Keep a backup that can’t get lost'),
    note('Browsers sometimes clear saved data. A link or file opens your design on any phone or computer.'),
    row(btn('Email it to me', () => emailBackup(cleanName(nameIn.value) || defaultSaveName())),
      btn('Download file', () => downloadBackup(cleanName(nameIn.value) || defaultSaveName())),
      btn('Copy link', () => copyShareLink()))));
  const file = h('input', { type: 'file', accept: '.txt,text/plain', hidden: true });
  file.addEventListener('change', () => {
    const f = file.files && file.files[0];
    if (!f || f.size > 200000) { if (f) toast('That file is not a FlowForge design.'); return; }
    f.text().then(t => {
      const c = codeFromText(t);
      if (!c) return toast('No FlowForge design found in that file.');
      try { openCode(c, f.name.replace(/^FlowForge - |\.txt$/g, '')); openSaves(false); } catch (e) { toast('That design file is damaged.'); }
    });
  });
  const paste = h('input', { type: 'text', class: 'ff-input', placeholder: 'Paste a design link or code', 'aria-label': 'Design link or code', autocomplete: 'off', spellcheck: 'false' });
  box.append(h('section', { class: 'ff-sec' }, h('h3', { class: 'ff-sec-title' }, 'Open a backup'),
    row(btn('Open a file', () => file.click()), file), paste,
    btn('Open pasted design', () => {
      let text = paste.value;
      try { text = decodeURIComponent(text); } catch (e) { /* a stray % : use the text as pasted */ }
      const c = codeFromText(text);
      if (!c) return toast('Paste the link or code from your email or file.');
      try { openCode(c); openSaves(false); } catch (e) { toast('That design code is damaged.'); }
    }, 'is-quiet')));
  const saves = readSaves();
  const list = h('div', { class: 'ff-saves' });
  saves.forEach((s, i) => {
    let thumb = '';
    try { thumb = renderSide(decodeDesignCode(s.code).designs[0], { idp: 'sv' + i, mode: 'thumb' }); } catch (e) {}
    list.append(h('div', { class: 'ff-save' + (s.id === ui.savedId ? ' is-on' : '') },
      h('button', { type: 'button', class: 'ff-save-open', 'aria-label': 'Open ' + s.name, onclick: () => { try { openCode(s.code, s.name, s.id); openSaves(false); } catch (e) { toast('That saved design is damaged.'); } } },
        h('span', { class: 'ff-look-img', html: thumb }), h('span', { class: 'ff-look-name' }, s.name), h('small', null, new Date(s.t).toLocaleDateString())),
      h('button', { type: 'button', class: 'ff-mini ff-save-del', 'aria-label': 'Delete ' + s.name, title: 'Delete', onclick: () => {
        const all = readSaves(), j = all.findIndex(x => x.id === s.id);
        if (j < 0) return;
        const gone = all.splice(j, 1)[0]; writeSaves(all);
        if (ui.savedId === gone.id) ui.savedId = '';
        after();
        toast('Deleted “' + gone.name + '”.', 'Undo', () => { const a = readSaves(); a.splice(j, 0, gone); writeSaves(a); if (!savesDialog().hidden) buildSaves(); });
      } }, '🗑')));
  });
  box.append(h('section', { class: 'ff-sec' }, h('h3', { class: 'ff-sec-title' }, 'Your saved designs', h('span', { class: 'ff-count' }, ' (' + saves.length + ')')),
    saves.length ? list : note('Nothing saved yet.')));
}

function wireWorkspace() {
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (savesDialog() && !savesDialog().hidden) openSaves(false);
    else if (layersPop() && !layersPop().hidden) openLayersPop(false);
  });
  /* click outside closes the Layers menu */
  document.addEventListener('pointerdown', e => {
    const pop = layersPop();
    if (pop && !pop.hidden && !pop.contains(e.target) && !e.target.closest('[data-act="layers"]')) openLayersPop(false);
  });
  const dlg = savesDialog();
  if (dlg) dlg.addEventListener('click', e => { if (e.target === dlg) openSaves(false); });
}

/* ── 99-init.js ── */
/* ── ADMIN PANEL (StarForge Admin only) ── */
function buildAdmin() {
  const box = $('[data-ff-admin]');
  if (!box || !ADMIN) return;
  const code = h('textarea', { class: 'ff-input', rows: '4', placeholder: 'Paste the FlowForge design code (SF1:… or SF2:…)', 'aria-label': 'Design code' });
  box.append(
    h('h3', { class: 'ff-sec-title' }, 'Order (Brian)'),
    h('input', { type: 'text', class: 'ff-input', 'data-admin': 'customer-name', placeholder: 'Customer name (e.g. John Smith)' }),
    h('input', { type: 'text', class: 'ff-input', 'data-admin': 'order-id', placeholder: 'Order # (e.g. FS-1042)' }),
    row(btn('Export all sides to print folder', e => exportAllToFolder(e.currentTarget), 'is-primary'), btn('Export this side (6000 px)', () => exportOnePNG())),
    h('h3', { class: 'ff-sec-title' }, 'Open design code (from the order email)'), code,
    row(btn('Open design', () => {
      try { applyDecoded(decodeDesignCode(code.value)); commit(); refreshPanel(true); requestRender(); toast('Design opened.'); }
      catch (e) { alert('Could not read that design code: ' + e.message); }
    }, 'is-primary')));
}

/* ── WIRING ── */
function wire() {
  ROOT.addEventListener('click', e => {
    const a = e.target.closest('[data-act]');
    if (a && ROOT.contains(a)) {
      const act = a.getAttribute('data-act');
      if (act === 'undo') { if (undo()) { refreshPanel(); requestRender(); } }
      else if (act === 'redo') { if (redo()) { refreshPanel(); requestRender(); } }
      else if (act === 'share') copyShareLink();
      else if (act === 'add-side') addSide();
      else if (act === 'continue') handoffToConfigurator();
      else if (act === 'save-image') saveShareImage();
      else if (act === 'zoom-in') setZoom(ui.view.zoom + 0.5);
      else if (act === 'zoom-out') setZoom(ui.view.zoom - 0.5);
      else if (act === 'layers') openLayersPop();
      else if (act === 'clear-all') blankCanvas();
      else if (act === 'save') openSaves(true);
      else if (act === 'close-saves') openSaves(false);
      else if (act === 'show-all') { ui.hide = {}; requestRender(); refreshLayersPop(); }
      return;
    }
    const v = e.target.closest('[data-view]');
    if (v) { toggleView(v.getAttribute('data-view')); return; }
    const s = e.target.closest('[data-side]');
    if (s && s.classList.contains('ff-side')) setSide(+s.getAttribute('data-side'));
  });
  const speed = $('[data-ff-speed]');
  if (speed) speed.addEventListener('input', () => setSpinSpeed(parseFloat(speed.value)));
  document.addEventListener('keydown', e => {
    if (!(e.ctrlKey || e.metaKey) || /^(INPUT|TEXTAREA|SELECT)$/.test((e.target && e.target.tagName) || '')) return;
    const k = e.key.toLowerCase();
    if (k === 'z' && !e.shiftKey) { e.preventDefault(); if (undo()) { refreshPanel(); requestRender(); } }
    else if ((k === 'z' && e.shiftKey) || k === 'y') { e.preventDefault(); if (redo()) { refreshPanel(); requestRender(); } }
  });
  wireStage();
  wireWorkspace();
}

/* the theme's sticky header covers the top of the page: pin the star (and, on phones, the tabs) below it */
function syncSticky() {
  let top = 0;
  const hdr = document.querySelector('.shopify-section-header-sticky, sticky-header');
  if (hdr) {
    const cs = getComputedStyle(hdr), r = hdr.getBoundingClientRect();
    if ((cs.position === 'sticky' || cs.position === 'fixed') && r.top <= 1 && r.bottom > 0) top = Math.round(r.bottom);
  }
  ROOT.style.setProperty('--ff-top', top + 'px');
  const sc = $('[data-ff-stagecol]');
  ROOT.style.setProperty('--ff-stage-h', (sc && window.matchMedia('(max-width:1023px)').matches ? sc.offsetHeight : 0) + 'px');
}

/* ── START ──
   1. a share link (#ff=SF2:…) opens that design;  2. otherwise this browser's last design;
   3. otherwise a curated look, so nobody starts at a blank star. */
function start() {
  buildTabs();
  wire();
  let opened = '';
  const m = location.hash.match(/[#&]ff=([^&]+)/);
  if (m) {
    try { applyDecoded(decodeDesignCode(decodeURIComponent(m[1]))); opened = 'link'; } catch (e) { toast('That design link is damaged, so a fresh design was opened.'); }
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
  }
  if (!opened && !ADMIN) {
    const draft = readDraft();
    if (draft) { try { applyDecoded(decodeDesignCode(draft)); opened = 'draft'; } catch (e) {} }
  }
  if (!opened && !ADMIN) state.designs[0] = deepClone(LOOKS[1].build());
  history.last = snapshot();
  setTab('looks');
  setZoom(1);
  buildAdmin();
  requestRender();
  if (opened === 'link') toast('Opened a shared design. Make it yours.');
  if (opened === 'draft') toast('Picked up where you left off.', 'Blank canvas', () => blankCanvas());
  syncSticky();
  let stickyQueued = false;
  const queueSticky = () => { if (stickyQueued) return; stickyQueued = true; requestAnimationFrame(() => { stickyQueued = false; syncSticky(); }); };
  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky);
  window.FlowForge = { version: '2.1.0', state, designCode, decodeDesignCode, renderSide };
}
start();
})();
